import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";
import Enums from "../../plugins/Enums";
const scanOk = require('../../../public/audio/scanOk.wav')
const scanErro = require('../../../public/audio/ScanErro.wav')
const reduceSumCv8 = (accumulator, cv8) => accumulator + cv8.cv8valor
import mixin from "@/plugins/mixins/mixin"
import Vue from 'vue';

export default {
	namespaced: true,
	state: {
		additionalPaymentMethods: [],
		lstVd1: [],
		vd1: {},
		insert: false,
		update: false,
		loading: false,
		loadingClient: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		since: moment().format("YYYY-MM-DD"),
		until: moment().format("YYYY-MM-DD"),
		pending: false,
		lstVd7: [],
		tabVdItem: 0,
		selectedPr0: null,
		tabBody: 0,
		showResume: false,
		consignedAlert: "",
		saleConfirmationAlert: "",
		validCashbackAlert: "",
		birthdayMonthAlert: "",
		customerNotification: 0,
		transmit: true,
		print: true,
		showDialogCustomer: false,
		showDialogPaymentProcessing: false,
		showDialogPaymentChargeback: false,
		currentDialogPaymentInfo: null,
		lxi: null,
		pixTimerEnd: null,
		lstCv8: [],
		lastVd4: null,
		snackbarLastVd4: false,
		lxdtitulo1: 0,
		lxdtitulo2: 0,
		lxdtitulo3: 0,
		newPaymentMethods: {},
		lstCv2: [],
		cv6: null,
		cv8Form: {
			installments: 0,
			days: 0,
			cv2titulo: ""
		},
		newCv8Form: {
			installments: 1,
			days: 30,
			cv2titulo: "",
			value: 1,
			cv8codnfce: null,
			cv8band: null,
			cv8agente: null,
			agency: null,
			cv8conta: null,
			cv8cmc7: null,
			ownerDocument: null,
			ownerName: null,
			cv8nsu: null,
		},
		calculatingInstallments: false,
		isFirstCalculation: true,
		docfis: "",
		lastFormCv8: Enums.PaymFormCV8.CONPGTO,
		billed: false,
		shipSequence: "",
		shoppingMessages: [],
		limitShoppingIntegration: 0,
		customerOldCredit: 0,
		lastDiscountCalcField: "percent",
		lstCv5: [],
		qtyVolumeLabel: 0,
		transporterInfos: {},
		isNewCustomer: false,
		shipmentQuote: null,
		orderStatus: [0,1],
		currentCv8Transaction: null,
		lstCashbacks: [],
		lstSelectedCashback: [],
		selectedCoupon: [],
		totalCredit: null,
		availableCredit: null,
		creditLimitAlert: "",
		shouldDisplayAlerts: false,
		whatsappCapability: {
			result: null,
			loading: false,
		},
		isSavedVD1: false,
	},
	getters: {
		itemsAmount(state){
			if (!state.lstVd7)
				return 0
			let amount = 0
			for (const vd7 of state.lstVd7) {
				const itemsAmount = (accumulator, item) => accumulator + item.total
				amount += vd7.items.reduce(itemsAmount, 0)
			}
			return amount
		},
		itemsOnCart(state){
			if (!state.lstVd7)
				return 0
			let qty = 0
			for (const vd7 of state.lstVd7) {
				const itemsQty = (accumulator, item) => accumulator + (!item.vd3qtde ? 0 : item.vd3qtde)
				qty += vd7.items.reduce(itemsQty, 0)
			}
			return qty
		},
		orderAmount(state){
			if (!state.lstVd7)
				return 0
			let amount = 0
			for (const vd7 of state.lstVd7) {
				const itemsAmount = (accumulator, item) => accumulator + item.total
				amount += vd7.items.reduce(itemsAmount, 0)
			}
			const cashback = state.lstSelectedCashback.length > 0 ? state.lstSelectedCashback[0].cb1valor : 0
			amount = amount + state.vd1.vd1vlfrete - state.vd1.vd1descon - state.vd1.vd1vltroca - cashback
			if(!!state.vd1.otherExpenses && Object.keys(state.vd1.otherExpenses).length > 0 && state.vd1.otherExpenses.constructor === Object)
				amount += state.vd1.otherExpenses.cv5outras
			amount = parseFloat(amount.toFixed(2))
			if(amount == 0)
				return 0
			return amount
		},
		installmentsAmount(state){
			return state.lstCv8 ? state.lstCv8.reduce(reduceSumCv8, 0) : 0
		},
		vd1model(state){
			if (!!state.lstCv8) {
				for (const cv8 of state.lstCv8) {
					cv8.cv8parcela = cv8.cv8parcela+""
					cv8.cv8pdvgrup = !!cv8.cv8fixo ? cv8.cv8fixo : cv8.additionalPaymentMethodId ? cv8.additionalPaymentMethodId.toString() : ""
				}
			}

			state.vd1.vd1cliente = state.vd1.vd1cliente ? state.vd1.vd1cliente.replace(/[^a-zA-Z0-9]/g, '') : ""

			if(!state.vd1.vd1descon)
				state.vd1.vd1descon = 0

			if(!state.vd1.vd1despon)
				state.vd1.vd1despon = 0

			state.vd1.vd1itmdesv = 0

			let totalOriginalPrice = 0
			for (const vd7 of state.lstVd7) {
				const totalCartItemDiscount = (accumulator, item) => accumulator + (item.changePricePr0 ? 0 : item.discount * item.vd3qtde)
				state.vd1.vd1itmdesv += vd7.items.reduce(totalCartItemDiscount, 0)
				totalOriginalPrice += vd7.items.reduce((accumulator, item) => accumulator + (item.vd5preco * item.vd3qtde), 0)
			}

			state.vd1.vd1itmdesp = (state.vd1.vd1itmdesv/totalOriginalPrice) * 100
			state.vd1.vd1trodesp = (state.vd1.vd1vltroca/totalOriginalPrice) * 100

			return {
				vd1: state.vd1,
				lstCv8: state.lstCv8,
				lstVd7: state.lstVd7,
				transmit: state.transmit,
				print: state.print,
				docfis: state.docfis,
				shipSequence: state.shipSequence,
				vdkmodel: null,
				qtyVolumeLabel: state.qtyVolumeLabel,
				othersAmountReturn: 0,
				shipmentQuote: state.shipmentQuote,
				isTefTransaction: false
			}
		},
		emitNFVd1Model(state){
			return {
				vd1pedido: state.vd1.vd1pedido,
				vd1cliente: state.vd1.vd1cliente,
				vd1consig: state.vd1.vd1consig,
				shipSequence: state.shipSequence,
				print: state.print,
			}
		},
		grossWeightAmount(state){
			if (!state.lstVd7)
				return 0
			let qty = 0
			for (const vd7 of state.lstVd7) {
				const grossWeightAmount = (accumulator, item) => {
					return accumulator + (!item.pr0pesobru ? 0 : item.pr0pesobru) * item.vd3qtde
				}
				qty += vd7.items.reduce(grossWeightAmount, 0)
			}
			return qty
		},
		netWeightAmount(state){
			if (!state.lstVd7)
				return 0
			let qty = 0
			for (const vd7 of state.lstVd7) {
				const netWeightAmount = (accumulator, item) => accumulator + (!item.pr0pesoliq ? 0 : item.pr0pesoliq) * item.vd3qtde
				qty += vd7.items.reduce(netWeightAmount, 0)
			}
			return qty
		},
		hasPendingTransactionWhileTef(state, _, rootState){
			if(rootState.lxd && rootState.lxd.lxd && rootState.lxd.lxd.lxdtef && !router.currentRoute.query.toIssueFiscalDocument){
				const integratedPayments = state.lstCv2 ? state.lstCv2.filter(el => el.cv2tpinteg == 1).map(el => el.cv2titulo) : []
				const integratedCv8 = state.lstCv8 ? state.lstCv8.filter(el => integratedPayments.includes(el.cv8tipotit)) : []
				const everyCv8IsTransacted = integratedCv8.every(el => el.cv8nsu != "" && el.cv8transac != "" && el.cv8transac)
				return !everyCv8IsTransacted
			}
			return false
			
		},
		lstCompletedTransactionWhileTef(state, _, rootState){
			if(rootState.lxd && rootState.lxd.lxd && rootState.lxd.lxd.lxdtef && !router.currentRoute.query.toIssueFiscalDocument){
				const integratedPayments = state.lstCv2 ? state.lstCv2.filter(el => el.cv2tpinteg == 1).map(el => el.cv2titulo) : []
				return state.lstCv8 ? state.lstCv8.filter(el => integratedPayments.includes(el.cv8tipotit) && el.cv8nsu != "" && el.cv8transac != "" && el.cv8transac) : []
			}
			return []
		},
		hasCompletedTransactionWhileTef(state, getters){
			return getters.lstCompletedTransactionWhileTef.length > 0;
		},
		hasIntegratedPaymentWhileTef(state, _, rootState){
			if(rootState.lxd && rootState.lxd.lxd && rootState.lxd.lxd.lxdtef && !router.currentRoute.query.toIssueFiscalDocument){
				const integratedPayments = state.lstCv2 ? state.lstCv2.filter(el => el.cv2tpinteg == 1).map(el => el.cv2titulo) : []
				const integratedCv8 = state.lstCv8 ? state.lstCv8.filter(el => integratedPayments.includes(el.cv8tipotit)) : []
				return integratedCv8.length > 0
			}
			return false
		},
		GeneratePixQrCodeModel(state){
			let request = null;
			if(state.currentCv8Transaction && state.lstCv8){
				const currentCv8Transaction = state.currentCv8Transaction
				const cv8Group = state.lstCv8.filter(el => el.additionalPaymentMethodId == currentCv8Transaction.additionalPaymentMethodId 
					&& el.cv8fixo == currentCv8Transaction.cv8fixo 
					&& el.cv8tipotit == currentCv8Transaction.cv8tipotit)
				request = {
					valor: cv8Group.reduce((a, b) => a + b.cv8valor, 0),
					vd1pedido: state.vd1.vd1pedido,
					lstCv8: cv8Group,
					cv2titulo: cv8Group[0].cv8tipotit
				}
			}
			return request;
		},
		finishPixPaymentModel(state){
			let request = null;
			if(state.currentCv8Transaction && state.lstCv8){
				const currentCv8Transaction = state.currentCv8Transaction
				const cv8Group = state.lstCv8.filter(el => el.additionalPaymentMethodId == currentCv8Transaction.additionalPaymentMethodId 
					&& el.cv8fixo == currentCv8Transaction.cv8fixo 
					&& el.cv8tipotit == currentCv8Transaction.cv8tipotit) 
				request = {
					automacaoColetaRetorno: currentCv8Transaction ? currentCv8Transaction.automacaoColetaRetorno : 0,
					automacaoColetaSequencial: currentCv8Transaction ? currentCv8Transaction.cv8lastseq : 0,
					lstCv8: cv8Group,
					vd1pedido: state.vd1.vd1pedido,
					timeout: 0
				}
			}
			return request;
		},
		cancelCurrentTransactionModel(state){
			let request = {};
			if(state.currentCv8Transaction && state.lstCv8){
				const currentCv8Transaction = state.currentCv8Transaction
				const cv8Group = state.lstCv8.filter(el => el.cv8transac == currentCv8Transaction.cv8transac) 
				request = {
					automacaoColetaSequencial: state.currentCv8Transaction && state.currentCv8Transaction.cv8lastseq ? state.currentCv8Transaction.cv8lastseq : 1,
					lxitransac: state.currentCv8Transaction ? state.currentCv8Transaction.cv8transac : 0,
					vd1pedido: state.vd1.vd1pedido,
					lstCv8: cv8Group,
					codNFCE: !!state.currentCv8Transaction ? state.currentCv8Transaction.cv8codnfce : 0
				}
			}
			return request
		},
		handleCardTransactionModel(state){
			let request = null;
			if(state.currentCv8Transaction && state.lstCv8){
				const currentCv8Transaction = state.currentCv8Transaction
				const cv8Group = state.lstCv8.filter(el => el.additionalPaymentMethodId == currentCv8Transaction.additionalPaymentMethodId 
					&& el.cv8fixo == currentCv8Transaction.cv8fixo 
					&& el.cv8tipotit == currentCv8Transaction.cv8tipotit)
				request = {
					lstCv8: cv8Group,
					vd1pedido: state.vd1.vd1pedido,
					cv2titulo: currentCv8Transaction.cv8tipotit,
					tipoPagamento: cv8Group.length == 1 ? 0 : 1,
					tipoCartao: currentCv8Transaction.cv8codnfce == 3 ? 1 : 0,
					valor: cv8Group.reduce((a, b) => a + b.cv8valor, 0),
					Lxitransac: currentCv8Transaction.cv8transac
				}
				if(request.tipoPagamento == 1){
					request.transacaoParcela = cv8Group.length
				}
				return request
			}
			return request;
		},
		hasInstallmentsBlock(state, _, rootState) {
			return rootState.cf1.hasInstallmentsBlock ? state.lstCv2.filter(el => el.cv2tippgto) : state.lstCv2
		}
	},
	mutations: {
		set(state, vd1){
			state.vd1 = vd1
			if (vd1){
				state.update = true
				state.lstVd7 = vd1.lstVd7
			}
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.billed = false
			state.transporterInfos = {}
			state.whatsappCapability.result = null
			state.whatsappCapability.loading = false
		},
		setParamsDataTable(state, payload){
			state.lstVd1 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		init(state, vd1){
			state.vd1 = vd1
		},
		clearCart(state){
			state.insert = false
			state.update = false
			state.vd1 = {}
			state.lstVd7 = []
			state.customerNotification = 0
			state.tabVdItem = 0
			state.selectedPr0 = null
			state.showResume = false
			state.consignedAlert = ""
			state.saleConfirmationAlert = ""
			state.validCashbackAlert = ""
			state.birthdayMonthAlert = ""
			state.transmit = true
			state.print = true
			state.showDialogCustomer = false
			state.showDialogPaymentProcessing = false
			state.showDialogPaymentChargeback = false
			state.currentDialogPaymentInfo = null
			state.lxi = null
			state.lstCv8 = []
			state.lastVd4 = null
			state.snackbarLastVd4 = false
			state.lxdtitulo1 = 0
			state.lxdtitulo2 = 0
			state.lxdtitulo3 = 0
			state.cv6 = null
			state.pixTimerEnd = null,
			state.cv8Form =  {
				installments: 0,
				days: 0,
				cv2titulo: ""
			}
			state.calculatingInstallments = false
			state.isFirstCalculation = true
			state.docfis = ""
			state.lastFormCv8 = Enums.PaymFormCV8.CONPGTO
			state.billed = false
			state.isSavedVD1 = false
			state.shipSequence = ""
			state.shoppingMessages = []
			state.limitShoppingIntegration = 0
			state.customerOldCredit = 0
			state.lstCv5 = []
			state.transporterInfos = {}
			state.isNewCustomer = false
			state.shipmentQuote = null
			state.orderStatus = [0,1]
			state.additionalPaymentMethods = []
			state.lstSelectedCashback = []
			state.whatsappCapability.result = null
			state.whatsappCapability.loading = false
		},
		setLstCashbacks(state, payload) {
			state.lstCashbacks = payload
		},
		setCustomerCredit(state, { totalCredit, availableCredit }) {
			state.totalCredit = totalCredit
			state.availableCredit = availableCredit
		},
		setWhatsappCapabilityLoading(state, value) {
			state.whatsappCapability.loading = value
		},
		hydrateWhatsappSendCapability(state, result) {
			state.whatsappCapability.result = result
			state.whatsappCapability.loading = false
		},
	},
	actions: {
		async init(store, vd1){
			let lxd = store.rootState.lxd.lxd

			let model = await store.dispatch("initModel", vd1)
			store.commit("init", model)
			store.state.insert = true
			await store.dispatch("getHeaderByLxdEan").then(headers => {
				store.state.lstVd7.push({ vd7volume: "1" , headers , items: [], vd1cliente: "", vd1descon: 0, vd1despon: 0, vd1vend: "", billed: false, lastDiscountCalcField : "percent", vd1pedido: "", issued: false, vd1vltroca: 0, customerOldCredit: 0 })
			})

			if (lxd.lxddevven){
				store.dispatch("vdk/init", {
					"vdkdoc": "",
					"vdkcliente": vd1.vd1cliente,
					"vdkmotivo": "",
					"vdkusuario": "",
					"vdkmanter": false,
					"vdkabert": new Date(),
					"vdkobserva": "",
				}, { root:true })
			}

			store.dispatch("saveCartLocalStorage", model)
			return true
		},
		initModel(store, vd1){
			return  {
				"id": vd1.id ? vd1.id : 0,
				"vd1pedido": vd1.vd1pedido ? vd1.vd1pedido : "",
				"vd1cliente": vd1.vd1cliente ? vd1.vd1cliente : "",
				"vd1repres": vd1.vd1repres ? vd1.vd1repres : "",
				"vd1transp": vd1.vd1transp ? vd1.vd1transp : "",
				"vd1pedrep": vd1.vd1pedrep ? vd1.vd1pedrep : "",
				"vd1entrada": vd1.vd1entrada ? vd1.vd1entrada : "",
				"vd1entrega": vd1.vd1entrega ? vd1.vd1entrega : "",
				"vd1conpgto": vd1.vd1conpgto ? vd1.vd1conpgto : "",
				"vd1lista": vd1.vd1lista ? vd1.vd1lista : "",
				"vd1opercom": vd1.vd1opercom ? vd1.vd1opercom : "",
				"vd1comis": vd1.vd1comis ? vd1.vd1comis : 0,
				"vd1descon": vd1.vd1descon ? vd1.vd1descon : 0,
				"vd1despon": vd1.vd1despon ? vd1.vd1despon : 0,
				"vd1desdias": vd1.vd1desdias ? vd1.vd1desdias : 0,
				"vd1frete": vd1.vd1frete ? vd1.vd1frete : 0,
				"vd1pronta": vd1.vd1pronta ? vd1.vd1pronta : false,
				"vd1consig": vd1.vd1consig ? vd1.vd1consig : false,
				"vd1redesp": vd1.vd1redesp ? vd1.vd1redesp : "",
				"vd1usuario": vd1.vd1usuario ? vd1.vd1usuario : "",
				"vd1docimp": vd1.vd1docimp ? vd1.vd1docimp : "",
				"vd1abert": vd1.vd1abert ? vd1.vd1abert : "",
				"vd1observa": vd1.vd1observa ? vd1.vd1observa : "",
				"vd1encerra": vd1.vd1encerra ? vd1.vd1encerra : "",
				"vd1excluir": vd1.vd1excluir ? vd1.vd1excluir : false,
				"vd1emissor": vd1.vd1emissor ? vd1.vd1emissor : "",
				"vd1vlfrete": vd1.vd1vlfrete ? vd1.vd1vlfrete : 0,
				"vd1local": vd1.vd1local ? vd1.vd1local : "",
				"vd1diasemb": vd1.vd1diasemb ? vd1.vd1diasemb : "",
				"vd1matcli": vd1.vd1matcli ? vd1.vd1matcli : 0,
				"vd1ecomped": vd1.vd1ecomped ? vd1.vd1ecomped : "",
				"vd1status": vd1.vd1status ? vd1.vd1status : "",
				"vd1statdes": vd1.vd1statdes ? vd1.vd1statdes : "",
				"vd1total": vd1.vd1total ? vd1.vd1total : 0,
				"vd1vend": vd1.vd1vend ? vd1.vd1vend : "",
				"vd1comven": vd1.vd1comven ? vd1.vd1comven : 0,
				"vd1pedpai": vd1.vd1pedpai ? vd1.vd1pedpai : "",
				"vd1tipo": vd1.vd1tipo ? vd1.vd1tipo : "",
				"vdedoc": vd1.vdedoc ? vd1.vdedoc : "",
				"dc4nome": vd1.dc4nome ? vd1.dc4nome : "",
				"cf1": vd1.cf1 ? vd1.cf1 : null,
				"vd1vltroca": vd1.vd1vltroca ? vd1.vd1vltroca : 0,
				"codAuthSalesMall": "",
				"consignmentAmount": vd1.consignmentAmount ? vd1.consignmentAmount : 0,
				"discountOriginal":  vd1.discountOriginal ? vd1.discountOriginal : 0,
				"toIssueFiscalDocument":  vd1.toIssueFiscalDocument ? vd1.toIssueFiscalDocument : false,
				"shippingInfoOfOrderModel":{
					"cv5qtdevol": vd1.cv5qtdevol ? vd1.cv5qtdevol : 1,
					"cv5espevol": vd1.cv5espevol ? vd1.cv5espevol : "avulso",
					"cv5pesobru": vd1.cv5pesobru ? vd1.cv5pesobru : vd1.vd1pesobru ? vd1.vd1pesobru : 0,
					"cv5pesoliq": vd1.cv5pesoliq ? vd1.cv5pesoliq : vd1.vd1pesoliq ? vd1.vd1pesoliq : 0,
					"cv5marcvol": vd1.cv5marcvol ? vd1.cv5marcvol : "",
					"cv5numevol": vd1.cv5numevol ? vd1.cv5numevol : "",
				},
				"otherExpenses":{
					"cv5outras":  vd1.cv5outras ? vd1.cv5outras : 0,
				},
				"vd1parcela":  vd1.vd1parcela ? vd1.vd1parcela : "",
				"vd1cash": vd1.vd1cash ? vd1.vd1cash : "",
				"vd1vlcash": vd1.vd1vlcash ? vd1.vd1vlcash : 0
			}
		},
		initForm(store){
			store.commit("initForm")
		},
		getHeaderByLxdEan(store){
			if (store.rootState.lxd.lxd.lxdean) {
				return [
					{ text: 'vdvpeca', align: 'left', value: 'vdvpeca' },
					{ text: 'vd2produto', value: 'vd2produto' },
					/* { text: 'pr0desc', value: 'pr0desc' },
					{ text: 'vd3opcao', value: 'vd3opcao' },
					{ text: 'vd3tamanho', value: 'vd3tamanho' }, */
					{ text: 'vd5preco', value: 'vd5preco' },
					{ text: 'vd3qtde', value: 'vd3qtde' },
					{ text: 'Desconto', value: 'discount' },
					{ text: 'Total', value: 'total' },
				]
			}
			return [
				{ text: 'vd8peca', align: 'left', value: 'vd8peca' },
				{ text: 'vd2produto', value: 'vd2produto' },
				/* { text: 'pr0desc', value: 'pr0desc' },
				{ text: 'vd3opcao', value: 'vd3opcao' },
				{ text: 'vd3tamanho', value: 'vd3tamanho' }, */
				{ text: 'vd5preco', value: 'vd5preco' },
				{ text: 'Desconto', value: 'discount' },
				{ text: 'Total', value: 'total' },
			]
		},
		async get(store, vd1pedido){
			return await this._vm.$axios.get(`/Order/Order/Find/${vd1pedido}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async find(store, vd1pedido){
			store.state.loading = true
			store.commit("initForm")
			await store.dispatch("get", vd1pedido)
			.then(vd1 => {
				store.commit("set", vd1)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return true
		},
		async recover(store, { vd1pedido, toIssueFiscalDocument, vdedoc } ){
			let lxd = store.rootState.lxd.lxd
			store.state.loading = true
			store.dispatch("clearCart")
			let payload = await this._vm.$axios.get(`/Order/Order/Recover/${vd1pedido}?toIssueFiscalDocument=${toIssueFiscalDocument}&recoverProductCache=true`)
			.then(async (response) => {
				let saveModel = Utils.ValidateAxiosResponse(response.data);
				store.state.update = true
				saveModel.vd1.vd1usuario = store.rootState.dc4.dc4.dc4usuario
				saveModel.vd1.dc4nome = store.rootState.dc4.dc4.dc4nome

				if(vdedoc && vdedoc != "")
					saveModel.vd1.vdedoc = vdedoc

				store.state.vd1 = await store.dispatch("initModel", saveModel.vd1)
				setTimeout(() => {
					if(saveModel.vd1.vd1cash != null && saveModel.vd1.vd1cash != "")
						store.dispatch("recoverCashback", saveModel.vd1.vd1cash);
				}, 2500);
				
				if (!!store.state.vd1.vd1parcela) {
					const vd1parcela = JSON.parse(store.state.vd1.vd1parcela)
					store.state.lstCv8 = vd1parcela.lstCv8
					if(toIssueFiscalDocument){
						store.state.lstCv8 = store.state.lstCv8.filter(cv8 => cv8.cv8tipotit != lxd.lxdtitulod)
					}
		
					store.state.lxdtitulo1 = vd1parcela.lxdtitulo1 ? parseFloat(vd1parcela.lxdtitulo1) : "";
					store.state.lxdtitulo2 = vd1parcela.lxdtitulo2 ? parseFloat(vd1parcela.lxdtitulo2) : "";
					store.state.lxdtitulo3 = vd1parcela.lxdtitulo3 ? parseFloat(vd1parcela.lxdtitulo3) : "";
					store.state.additionalPaymentMethods = vd1parcela.additionalPaymentMethods ?? [];
				} 
				
				if(!!store.state.vd1.vd1conpgto) {
					let vd4 = await store.dispatch("vd4/get", store.state.vd1.vd1conpgto, { root: true })
					if(vd4){
						store.state.cv8Form.installments = vd4.lstVd9.length > 0 ? vd4.lstVd9.length : 0
						store.state.cv8Form.days = vd4.lstVd9.length > 0 ? vd4.lstVd9[0].vd9caren : 0
						store.state.cv8Form.cv2titulo = vd4.vd4titulo
					}
				}
				
				await store.dispatch("getHeaderByLxdEan").then(headers => {
					for (const vd7 of saveModel.lstVd7) {
						vd7.headers = headers
						vd7.vd1pedido = saveModel.vd1.vd1pedido
						vd7.vd1cliente = saveModel.vd1.vd1cliente
					}
					store.state.lstVd7 = saveModel.lstVd7
				})

				//dados de devolução
				if (lxd.lxddevven && !!saveModel.vdkmodel && !toIssueFiscalDocument) {
					store.dispatch("vdk/set", saveModel.vdkmodel.vdk, { root: true })
					for (const item of saveModel.vdkmodel.lstItems) {
						item.vdxpeca = item.eancodigo
						item.vdlpeca = item.of3peca
					}
					store.rootState.vdk.insert = true
					store.dispatch("vdk/getHeaderByLxdEan", null, { root: true })
					.then(headers => {
						store.rootState.vdk.carts = [{
							lstItems: saveModel.vdkmodel.lstItems,
							volume: "1",
							vdkcliente: saveModel.vd1.vd1cliente,
							headers
						}]
					})
					store.dispatch("vdk/calculateTaxes", null, { root: true })
					store.rootState.vdk.consigned = lxd.lxdean && lxd.lxdmoddev ? false : lxd.lxddocdev2 == saveModel.vdkmodel.docfis
					store.rootState.vdk.docfis = saveModel.vdkmodel.docfis
					store.rootState.vdk.emispro = saveModel.vdkmodel.emispro
					store.rootState.vdk.docReturn = saveModel.vdkmodel.docReturn
				}
				//dados documento fiscal
				if (toIssueFiscalDocument) {
					let lstCv5 = await store.dispatch("findAllCv5", saveModel.vd1.vd1pedido)
					store.state.vd1.shippingInfoOfOrderModel.cv5numevol = lstCv5[0]?.cv5numevol ?? ""
					store.state.vd1.shippingInfoOfOrderModel.cv5marcvol = lstCv5[0]?.cv5marcvol ?? ""
					store.state.vd1.shippingInfoOfOrderModel.cv5pesoliq = lstCv5[0]?.cv5pesoliq ?? store.state.vd1.vd1pesoliq ?? 0
					store.state.vd1.shippingInfoOfOrderModel.cv5pesobru = lstCv5[0]?.cv5pesobru ?? store.state.vd1.vd1pesobru ?? 0
					store.state.vd1.shippingInfoOfOrderModel.cv5espevol = lstCv5[0]?.cv5espevol ?? ""
					store.state.vd1.shippingInfoOfOrderModel.cv5qtdevol = lstCv5[0]?.cv5qtdevol ?? 0
					store.state.vd1.otherExpenses.cv5outras = lstCv5[0]?.cv5outras ?? 0
					await store.dispatch("calculateCart", false)
				}

				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message,
					cancelAction: () => router.push("/oryxpdv/pedidos")
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async save(store, isTefTransaction = false){
			let lxd = store.rootState.lxd.lxd
			let payload; 

			if (!isTefTransaction)
				store.state.currentCv8Transaction = null
			
			if(store.state.docfis && (store.state.docfis == lxd.lxddocven2 || store.state.docfis == lxd.lxddocven5) && !store.getters.hasIntegratedPaymentWhileTef){
				store.state.vd1.vd1vltroca = 0
				await store.dispatch("calculateCart", false)
			}

			if (store.getters.orderAmount < 0 && !store.getters.hasIntegratedPaymentWhileTef){
				store.state.vd1.vd1vltroca = store.getters.orderAmount + store.state.vd1.vd1vltroca
				store.state.vd1.vd1vltroca = parseFloat(store.state.vd1.vd1vltroca.toFixed(2))
				await store.dispatch("calculateCart", false)
			}

			if (store.state.vd1.toIssueFiscalDocument && store.state.update){
				store.dispatch("emitFiscalDocument", { docfis: store.state.docfis, isSales: true })
				return
			}

			// múltiplos romaneios
			if (lxd.lxdmultrom && store.state.lstVd7.length > 1) {
				store.dispatch("insertNextVd7")
				return
			}

			if (store.state.update || store.state.isSavedVD1){
				payload = await store.dispatch("update", isTefTransaction)
				return payload
			}
			else{

				store.state.vd1.vd1pedido = await store.dispatch("getNextNumber")
			
				if (store.state.vd1.vd1pedido) {
					payload = await store.dispatch("insert", isTefTransaction)
					return payload
				}
			}


		},
		async insert(store, isTefTransaction = false){
			let vd1model = store.getters.vd1model
			let lxd = store.rootState.lxd.lxd
			let vdk = store.rootState.vdk.vdk
			let lx0 = store.rootState.lx0.lx0
			let vdedoc = vd1model.vd1.vdedoc

			if (lxd.lxddevven && vdk) {
				let vdkmodel = store.rootGetters["vdk/vdkmodel"]

				vd1model.vdkmodel = vdkmodel
				vd1model.vdkmodel.carts = store.rootGetters["vdk/carts"]
				vd1model.vdkmodel.lstItems = vd1model.vdkmodel.carts[0].lstItems
				vd1model.vdkmodel.docReturn = store.rootGetters["vdk/docReturn"]
			}

			vd1model.isTefTransaction = isTefTransaction
			vd1model.vd1.vd1parcela = vd1model.vd1.vd1parcela != "" ? vd1model.vd1.vd1parcela : JSON.stringify({lstCv8: store.state.lstCv8, lxdtitulo1: store.state.lxdtitulo1, lxdtitulo2: store.state.lxdtitulo2, lxdtitulo3: store.state.lxdtitulo3, additionalPaymentMethods: store.state.additionalPaymentMethods})

			vd1model.printOnReturn = await store.dispatch("printOnReturn", vd1model)

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: isTefTransaction ? "Preparando o Checkout" : "Gravando pedido", indeterminate: true }, {root: true})
			const payload = await this._vm.$axios.post("/Order/Order/Insert", vd1model )
			.then(async response => {

				let payload = Utils.ValidateAxiosResponse(response.data);

				if(!payload.isError && vd1model.printOnReturn){

					await this._vm.$tefAxios.post("/TEF/PrintSaleAndReceipt/", {vd1pedido: vd1model.vd1.vd1pedido, shipSequence: payload.shipSequence}).then(response => {
						const relatPath = Utils.ValidateAxiosResponse(response.data);

						if (relatPath && relatPath.length > 0)
							store.dispatch("print/openLocalRelatsPath", [relatPath], {
								root: true,
							});
						
						return relatPath
					}).catch((error) => {
						store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						}, { root: true })
						return false
					});
				}
				store.state.vd1.codAuthSalesMall = payload.codAuthSalesMall
				store.state.billed = payload.billed
				store.state.isSavedVD1 = payload.isSavedVD1
				store.state.shipSequence = payload.shipSequence
				if (store.rootState.vdk.vdk){
					store.rootState.vdk.vdk.vdkdoc = payload.vdkdoc
				}
				store.dispatch("saveCartLocalStorage")

				if(!payload.isError && vd1model.docfis == lxd.lxddocven1){
					let success = await store.dispatch("emitBankSlipByPaymentCondition");

					if (success)
						store.dispatch("requestEmitNF", payload)
				}else{
					let processSuccess = async () => {
						if(vd1model.docfis != lxd.lxddocven2 && !isTefTransaction){
							let success = await store.dispatch("emitBankSlipByPaymentCondition");

							if (lx0.lx0email && success && vd1model.docfis && vd1model.docfis != lxd.lxddocven1 && vd1model.docfis != lxd.lxddocven2) {
								await store.dispatch("sendNfeEmailByOrder", { vd1pedido: store.state.vd1.vd1pedido, vd1cliente: store.state.vd1.vd1cliente })
							}

							if(!success)
								return false
						}

						const vd1pedido = store.state.vd1.vd1pedido
						if(isTefTransaction){
							await router.push({path: `/oryxpdv/venda/${vd1pedido}`, query: { parcela: store.state.currentCv8Transaction.cv8parcela}})
							//Ao redirecionar, a lógica para abrir o dialog do TEF está no mounted do OryxCartPayments
							await store.dispatch("recover", { vd1pedido: router.currentRoute.params.vd1pedido, toIssueFiscalDocument: router.currentRoute.query.toIssueFiscalDocument == "true", vdedoc })

							if(!store.state.cv6){
								store.dispatch("cv6/get", store.state.vd1.vd1lista, {root: true})
							}

							return;
						} else {
							store.dispatch("clearCart")
							router.push("/oryxpdv/venda-concluida")
						}
						return true
					}

					if(isTefTransaction && !payload.enableNewOrderButton){
						await processSuccess()
					}else{
						store.dispatch("parameters/openDialog", {
							titleText: payload.isError ? "Erro" : payload.message,
							titleColor: payload.isError ? "red" : "green",
							text: payload.isError ? payload.message + (payload.enableNewOrderButton ? "<br/>Você pode <b>emitir uma nova venda</b> e gerar outro número de pedido, ou <b>abandonar a tela</b>.": "") : "",
							cancelText: payload.isError && payload.enableNewOrderButton ? "Emitir novo pedido" : "Ok",
							cancelAction: async () => {
								if(payload.isError && payload.enableNewOrderButton){
									store.dispatch("resalesByUsedOrderNumber")
									return
								}
								if (!payload.isError) {
									await processSuccess()
									return
								}
	
							},
							confirmAction: async () => {
								if (!payload.isError) {
									await processSuccess()
									return
								}
							},
							confirmText: "Ok",
							confirmBtn: payload.isError && payload.enableNewOrderButton
						}, { root: true })
					}

				}

				if (!payload.isError) {
					if(payload.relatsPath && payload.relatsPath.length > 0 && !isTefTransaction){
						store.dispatch("print/openRelatsPath", payload.relatsPath, { root: true })
					}

					store.dispatch("removeCartLocalStorage", vd1model.vd1.id )
				}
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async update(store, isTefTransaction = false){
			let vd1model = store.getters.vd1model
			let vdk = store.rootState.vdk.vdk
			let lxd = store.rootState.lxd.lxd
			let lx0 = store.rootState.lx0.lx0
			let hasIntegratedPaymentWhileTef = store.getters.hasIntegratedPaymentWhileTef

			if (lxd.lxddevven && vdk) {
				let vdkmodel = store.rootGetters["vdk/vdkmodel"]

				vd1model.vdkmodel = vdkmodel
				vd1model.vdkmodel.carts = store.rootGetters["vdk/carts"]
				vd1model.vdkmodel.lstItems = vd1model.vdkmodel.carts[0].lstItems
				vd1model.vdkmodel.docReturn = store.rootGetters["vdk/docReturn"]
			}

			vd1model.isTefTransaction = isTefTransaction
			vd1model.vd1.vd1parcela = 
			store.state.lstCv8 ? JSON.stringify({lstCv8: store.state.lstCv8, lxdtitulo1: store.state.lxdtitulo1, lxdtitulo2: store.state.lxdtitulo2, lxdtitulo3: store.state.lxdtitulo3, additionalPaymentMethods: store.state.additionalPaymentMethods}) 
			: vd1model.vd1.vd1parcela != "" ? vd1model.vd1.vd1parcela
			: ""

			vd1model.printOnReturn = await store.dispatch("printOnReturn", vd1model)
			
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: isTefTransaction ? "Preparando o Checkout" : "Gravando pedido", indeterminate: true }, {root: true})
			const payload = await this._vm.$axios.put("/Order/Order/Update", vd1model )
			.then(async response => {

				let payload = Utils.ValidateAxiosResponse(response.data);
				let printResponse = true
				let isError = payload.isError

				if(!payload.isError && vd1model.printOnReturn){

					printResponse = await this._vm.$tefAxios.post("/TEF/PrintSaleAndReceipt/", {vd1pedido: vd1model.vd1.vd1pedido, shipSequence: payload.shipSequence}).then(response => {
						const relatPath = Utils.ValidateAxiosResponse(response.data);

						if (relatPath && relatPath.length > 0)
							store.dispatch("print/openLocalRelatsPath", [relatPath], {
								root: true,
							});
						
						return relatPath
					}).catch((error) => {
						isError = true;
						store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						}, { root: true })
						return false
					});
				}

				if(!isError && store.rootState.lxd && store.rootState.lxd.lxd.lxdtef && !isTefTransaction && hasIntegratedPaymentWhileTef && printResponse)
					await this._vm.$tefAxios.put("/TEF/ExecuteAllTransactions/" + vd1model.vd1.vd1pedido )

				store.state.vd1.codAuthSalesMall = payload.codAuthSalesMall
				store.state.billed = payload.billed
				store.state.isSavedVD1 = payload.isSavedVD1
				store.state.shipSequence = payload.shipSequence

				if (store.rootState.vdk.vdk){
					store.rootState.vdk.vdk.vdkdoc = payload.vdkdoc
				}

				store.dispatch("saveCartLocalStorage")

				if(!payload.isError && vd1model.docfis == lxd.lxddocven1){
					let success = await store.dispatch("emitBankSlipByPaymentCondition");

					if (success)
						store.dispatch("requestEmitNF", payload)
				}else{
					let processSuccess = async () => {
						if(vd1model.docfis != lxd.lxddocven2 && !isTefTransaction){
							let success = await store.dispatch("emitBankSlipByPaymentCondition");

							if (lx0.lx0email && success && vd1model.docfis && vd1model.docfis != lxd.lxddocven1 && vd1model.docfis != lxd.lxddocven2) {
								await store.dispatch("sendNfeEmailByOrder", { vd1pedido: store.state.vd1.vd1pedido, vd1cliente: store.state.vd1.vd1cliente })
							}

							if(!success)
								return false
						}

						if(isTefTransaction){
							return false;
						} else {
							store.dispatch("clearCart")
							router.push("/oryxpdv/venda-concluida")
						}
						return true
					}

					if(isTefTransaction && !payload.enableNewOrderButton){
						await processSuccess()
					}else{
						store.dispatch("parameters/openDialog", {
							titleText: payload.isError ? "Erro" : payload.message,
							titleColor: payload.isError ? "red" : "green",
							text: payload.isError ? payload.message + (payload.enableNewOrderButton ? "<br/>Você pode <b>emitir uma nova venda</b> e gerar outro número de pedido, ou <b>abandonar a tela</b>.": "") : "",
							cancelText: payload.isError && payload.enableNewOrderButton ? "Emitir novo pedido" : "Ok",
							cancelAction: async () => {
								if(payload.isError && payload.enableNewOrderButton){
									store.dispatch("resalesByUsedOrderNumber")
									return
								}
								if (!payload.isError) {
									await processSuccess()
									return
								}
	
							},
							confirmAction: async () => {
								if (!payload.isError) {
									await processSuccess()
									return
								}
							},
							confirmText: "Ok",
							confirmBtn: payload.isError && payload.enableNewOrderButton
						}, { root: true })
					}
				}

				if (!payload.isError) {
					if(payload.relatsPath && payload.relatsPath.length > 0 && !isTefTransaction){
						store.dispatch("print/openRelatsPath", payload.relatsPath, { root: true })
					}

					store.dispatch("removeCartLocalStorage", store.getters.vd1model.vd1.id )
				}
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async delete(store, {redirect = true, alert = true, authorized = false}){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluíndo pedido", indeterminate: true }, {root: true})
			const payload = await this._vm.$axios.delete(`/Order/Order/Delete/${store.state.vd1.vd1pedido}?authorized=${authorized}`)
			.then(async response => {
				Utils.ValidateAxiosResponse(response.data);

				let success = true
				if (store.rootState.lxd.lxd.lxdtef) {
					success = await store.dispatch("lxi/findByOrder", { lxipedido: store.state.vd1.vd1pedido, lstLxistatus: [ Enums.TEFTransactionStateType.COMPLETED ]}, { root: true })
					.then(async lstLxi =>{
						if (!lstLxi)
							return false
						for (const lxi of lstLxi) {
							let payload = await store.dispatch("lxi/cancelTransaction", 
							{
								cancelCurrentTransactionModel : { 
									lxitransac: lxi.lxitransac,
									vd1pedido: store.state.vd1.vd1pedido,
									codNFCE: lxi.nfceCode,
									sequencial: !!lxi.lxiseq ? parseInt(lxi.lxiseq) : 0,
									revertTransactionNsu: true
								},
								isInSales: false
							}, { root: true })
							if (payload == false || payload.lxi == null || payload.lxi == undefined) 
								return false
						}
						return true
					})
				}
				if (!success)
					return success

				if(alert){
					store.dispatch("parameters/showSnackBar", {
						show: true,
						timeout: 3000,
						text: `Pedido excluído com sucesso`,
						color: "green"
					}, { root: true })
				}
				
				if(redirect)
					router.push("/oryxpdv/pedidos")
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload;
		},
		async search(store, { limit = 20, page = 1, orderBy = "DESC"}){
			store.state.loading = true
			store.commit("initForm")

			if(store.state.orderStatus.length == 0)
				store.state.orderStatus = [0,1]

			let orderStatus = ""
			for (const status of store.state.orderStatus) {
				orderStatus += "&orderStatus=" + status
			}
			let url = `/Order/Order/Search?search=${store.state.search}&pending=${store.state.pending}&limit=${limit}&page=${page}&orderBy=${orderBy}${orderStatus}`
			if (store.state.since) {
				url+= `&since=${store.state.since}`
			}
			if (store.state.until) {
				url+= `&until=${store.state.until}`
			}
			let payload = await this._vm.$axios.get(url)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstVd1 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		addVdItem(store, { pr0, prefix, silent }){
			var audio = new Audio(scanOk);
			let lxd = store.rootState.lxd.lxd

			//pegando o volume
			let vd7 = store.state.lstVd7[store.state.tabVdItem]
			if (vd7) {
				if (prefix == "vdv"){
					let item = vd7.items.filter(v => {
						return v.vd2produto == pr0.pr0produto &&
							v.vd3opcao == pr0.pr2opcao &&
							v.vd3tamanho == pr0.pr3tamanho &&
							v.vdvpeca == pr0.vdvpeca &&
							v.vd5preco == pr0.vd5preco &&
							v.discount == pr0.discount
						})[0]
					if (item){
						item.vd3qtde += pr0.vd3qtde
						item.stock = pr0.stock
						//calculando o total da linha
						item.total = parseFloat((item.vd5preco).toFixed(2) * item.vd3qtde)
						store.dispatch("calculateCart")
						store.dispatch("calculateWeight")

						if (lxd.lxdestneg)
							store.dispatch("checkStockForVdItem", { vd2produto: item.vd2produto, vd3opcao: item.vd3opcao, vd3tamanho: item.vd3tamanho, stock: item.stock })

						if(!silent)
							audio.play();

						return true
					}
				}else{
					for (const volume of store.state.lstVd7) {
						if(volume.items.filter(v => v.vd8peca == pr0.vd8peca).length > 0){
							if(!silent){
								store.dispatch("parameters/openDialog", {
									titleText: "Erro",
									titleColor: "red",
									text: "Produto já incluído"
								}, { root: true })

								var audioErro = new Audio(scanErro);
								audioErro.play();
							}

							return false
						}
					}
				}
				//calculando o total da linha
				pr0.total = parseFloat((pr0.vd5preco).toFixed(2) * pr0.vd3qtde)
				//adicionando no volume
				vd7.items.unshift({
					"pr0imagem": pr0.pr0imagem,
					"vd2produto": pr0.pr0produto,
					"pr0desc": pr0.pr0desc,
					"vd3opcao": pr0.pr2opcao,
					"pr2cor": pr0.pr2cor,
					"vd3tamanho": pr0.pr3tamanho,
					"vd3qtde": pr0.vd3qtde,
					"vd5preco": pr0.vd5preco,
					"total": pr0.total,
					"vdvpeca": pr0.vdvpeca,
					"vd8peca": pr0.vd8peca,
					"vd3leitura": moment(new Date()).format("YYYY-MM-DDTHH:mm:ssZ"),
					"priceList": pr0.vd5preco,
					"onlyNF": pr0.onlyNF ? pr0.onlyNF : false,
					"of3rfid": pr0.of3rfid,
					"cr1nome": pr0.cr1nome,
					"pr0pesobru": pr0.pr0pesobru,
					"pr0pesoliq": pr0.pr0pesoliq,
					"pr0largura": pr0.pr0largura,
					"pr0altura": pr0.pr0altura,
					"pr0comprim": pr0.pr0comprim,
					"stock": pr0.stock,
					"originalQty": pr0.vd3qtde,
					"saleConfirmationItem": pr0.saleConfirmationItem,
					"discount": pr0.discount,
					"changePricePr0": pr0.changePricePr0,
					"valueWithDiscount": pr0.vd5preco,
				})
				store.dispatch("calculateCart")
				store.dispatch("calculateWeight")

				if (lxd.lxdestneg)
					store.dispatch("checkStockForVdItem", { vd2produto: pr0.pr0produto, vd3opcao: pr0.pr2opcao, vd3tamanho: pr0.pr3tamanho, stock: pr0.stock })

				if(!silent)
					audio.play();

				if (lxd.lxdmultrom && store.state.lstVd7.length > 1)
					store.dispatch("calculatevd1vltroca")

				return true
			}
			return false
		},
		changeSelectedPr0(store, vditem){
			store.state.selectedPr0 = vditem
		},
		saveCartLocalStorage(store, model){
			if (store.state.update)
				return

			let vd1 = model ? model : store.state.vd1
			let pd0 = JSON.parse(localStorage.getItem("terminal"))
			let lstVd1 = pd0.lstVd1

			let cart = lstVd1.filter(v => v.id == vd1.id)[0]
			let vdk = null
			if (store.rootState.lxd.lxd.lxddevven && store.rootState.vdk.vdk){
				vdk = store.rootState.vdk.vdk
				vdk.carts = store.rootState.vdk.carts
			}
			if (cart) {
				cart.id = vd1.id
				cart.vd1 = vd1
				cart.lstVd7 = store.state.lstVd7
				cart.lstCv8 = store.state.lstCv8
				cart.billed = store.state.billed
				cart.additionalPaymentMethods = store.state.additionalPaymentMethods
				cart.lstSelectedCashback = store.state.lstSelectedCashback
				cart.vdk = vdk

				lstVd1 = lstVd1.filter(v => v.id != vd1.id)
			}else{
				cart = {
					id: vd1.id,
					vd1,
					lstVd7: store.state.lstVd7,
					insert: store.state.insert,
					update: store.state.update,
					lstCv8: store.state.lstCv8,
					billed: store.state.billed,
					additionalPaymentMethods: store.state.additionalPaymentMethods,
					lstSelectedCashback: store.state.lstSelectedCashback,
					vdk
				}
			}
			if(cart.id)
				lstVd1.push(cart)

			pd0.lstVd1 = lstVd1
			localStorage.removeItem("terminal")
			localStorage.setItem("terminal", JSON.stringify(pd0))
		},
		recoverCartLocalStorage(store, { pd0json, id }){
			let pd0 = JSON.parse(pd0json)
			let lstVd1 = pd0.lstVd1
			let cart = lstVd1.find(v => v.id == id)
			if (cart) {
				store.state.vd1 = cart.vd1
				store.state.lstVd7 = cart.lstVd7
				store.state.insert = cart.insert
				store.state.update = cart.update
				store.state.lstCv8 = cart.lstCv8
				store.state.billed = cart.billed
				store.state.lstSelectedCashback = cart.lstSelectedCashback
				store.state.additionalPaymentMethods = cart.additionalPaymentMethods ?? []
				if(cart.vdk && store.rootState.lxd.lxd.lxddevven){
					store.rootState.vdk.insert = true
					store.rootState.vdk.carts = cart.vdk.carts
					store.rootState.vdk.vdk = cart.vdk
				}
				store.dispatch("calculateCart")
				if(store.state.vd1.cf1 && store.state.vd1.cf1.cf1nome)
					document.title = "Oryx PDV - " + store.state.vd1.cf1.cf1nome
			}
			return true
		},
		removeCartLocalStorage(store, id){
			let pd0 = JSON.parse(localStorage.getItem("terminal"))
			localStorage.removeItem("terminal")
			let lstVd1 = pd0.lstVd1
			pd0.lstVd1 = lstVd1.filter(v => v.id != id)
			localStorage.setItem("terminal", JSON.stringify(pd0))
		},
		clearCart(store){
			store.commit("clearCart")
		},
		async calculateCart(store, calculatevd1vltroca = true){
			if(!!calculatevd1vltroca)
				await store.dispatch("calculatevd1vltroca")
			await store.dispatch("calculateDiscount")
			store.state.vd1.vd1total = store.getters.orderAmount
			await store.dispatch("calculateCv8", {})
			store.dispatch("saveCartLocalStorage")
			return true
		},
		calculateDiscount(store){
			let lxd = store.rootState.lxd.lxd
			let amount = store.getters.itemsAmount

			if (lxd.lxdmultrom && store.state.lstVd7.length > 1) {
				let discountAmount = 0
				store.state.lstVd7.forEach(vd7 => {
					const itemsAmount = (accumulator, item) => accumulator + item.total
					let subtotal = vd7.items.reduce(itemsAmount, 0)

					if(!lxd.lxddescbru)
						subtotal -= vd7.vd1vltroca

					if(vd7.lastDiscountCalcField == "percent") {
						vd7.vd1despon = !!vd7.vd1despon ? parseFloat(vd7.vd1despon.toFixed(3)) : 0
						vd7.vd1descon = !!vd7.vd1despon ? parseFloat((subtotal * (vd7.vd1despon/100)).toFixed(2)) : 0
					} else {
						vd7.vd1descon = !!vd7.vd1descon ? parseFloat(vd7.vd1descon.toFixed(2)) : 0
						vd7.vd1despon = !!vd7.vd1descon ? parseFloat(((vd7.vd1descon / subtotal) * 100).toFixed(3)) : 0
					}
					discountAmount += vd7.vd1descon
				});

				store.state.vd1.vd1descon = discountAmount
				store.state.vd1.vd1despon = parseFloat(((discountAmount / amount) * 100).toFixed(3))
				return true
			}

			if(!lxd.lxddescbru)
				amount -= store.state.vd1.vd1vltroca
			if(store.state.lastDiscountCalcField == "percent"){
				store.state.vd1.vd1despon = parseFloat(store.state.vd1.vd1despon.toFixed(3))
				store.state.vd1.vd1descon = parseFloat((amount * (store.state.vd1.vd1despon/100)).toFixed(2))
			}else{
				store.state.vd1.vd1descon = parseFloat(store.state.vd1.vd1descon.toFixed(2))
				store.state.vd1.vd1despon = parseFloat(((store.state.vd1.vd1descon / amount) * 100).toFixed(3))
			}

			return true
		},
		async selectVd1Lista(store, {cv6 = null, calculateCart = true}){
			if (!cv6) {
				return
			}
			
			await store.dispatch("calculatePriceItems")

			store.state.cv6 = cv6
			if (!!store.state.cv6.cv6conpgto)
			{
				store.state.lastFormCv8 = Enums.PaymFormCV8.CONPGTO
				store.state.vd1.vd1conpgto = store.state.cv6.cv6conpgto
			}
			if(calculateCart)
				store.dispatch("calculateCart")
		},
		sortAdditionalPaymentMethod(store) {
			let id = 1
			for (const additionalPaymentMethod of store.state.additionalPaymentMethods) {
				additionalPaymentMethod.id = id
				id++
			}
		},
		async addNewPaymentMethod(store) {
			let newPaymentMethod = {
				days: store.state.newCv8Form.days,
				installmentQuantity: store.state.newCv8Form.installments,
				installments: [],
				installmentValue: parseFloat((store.state.newCv8Form.value / store.state.newCv8Form.installments).toFixed(2)),
				value: store.state.newCv8Form.value
			}
			for (let i = 0; i < newPaymentMethod.installmentQuantity; i++) {
				newPaymentMethod.installments.push({
					cv8tipotit: store.state.newCv8Form.cv2titulo,
					cv8cmc7: store.state.newCv8Form.cv8codnfce == Enums.CodNFCE.Cheque ? store.state.newCv8Form.cv8cmc7 + i + "" ?? "" : "",
					cv8valor: newPaymentMethod.installmentValue,
					cv8vencim: moment().add(newPaymentMethod.days * (i + 1), "days").format("YYYY-MM-DD"),
					cv8agente: store.state.newCv8Form.cv8agente ?? "",
					cv8nsu: store.state.newCv8Form.cv8nsu ?? "",
					cv8band: store.state.newCv8Form.cv8band ?? "",
					cv8codnfce: store.state.newCv8Form.cv8codnfce,
					cv8fixo: "",
					interval: newPaymentMethod.days,
					term: newPaymentMethod.days * (i + 1),
					fixedValue: true,
					agency: store.state.newCv8Form.agency ?? "",
					cv8conta: store.state.newCv8Form.cv8conta ?? "",
					ownerName: store.state.vd1.vd1cliente != store.state.newCv8Form.ownerDocument ? (store.state.vd1.cf1 && store.state.vd1.cf1.cf1nome) ?? "" : store.state.newCv8Form.ownerName,
					ownerDocument: store.state.vd1.vd1cliente != store.state.newCv8Form.ownerDocument ? store.state.vd1.vd1cliente : store.state.newCv8Form.ownerDocument,
				})
			}
			store.state.additionalPaymentMethods.push(newPaymentMethod)
			store.state.newCv8Form = {
				installments: 1,
				days: 30,
				cv2titulo: "",
				value: 1,
				cv8codnfce: null,
				cv8band: null,
				cv8agente: null,
				agency: null,
				cv8conta: null,
				cv8cmc7: null,
				ownerDocument: null,
				ownerName: null,
				cv8nsu: null,
			},
			store.dispatch("sortAdditionalPaymentMethod")
			store.dispatch("calculateCv8", {})
		},
		removeAdditionalPaymentMethod(store, cv8) {
			let additionalPaymentMethod = store.state.additionalPaymentMethods.find(item => 
				item.id == cv8.additionalPaymentMethodId 
			)
			additionalPaymentMethod.installments = additionalPaymentMethod.installments
				.filter(installment => installment.cv8parcela != cv8.cv8parcela)

			store.state.lstCv8 = store.state.lstCv8.filter(installment => installment.cv8parcela != cv8.cv8parcela)

			additionalPaymentMethod.installmentQuantity = additionalPaymentMethod.installments.length
			additionalPaymentMethod.installmentValue = parseFloat((additionalPaymentMethod.value / additionalPaymentMethod.installmentQuantity).toFixed(2))

			if(additionalPaymentMethod.installmentQuantity == 0){
				store.state.additionalPaymentMethods = store.state.additionalPaymentMethods.filter(item => item.id != cv8.additionalPaymentMethodId)
			} else {
				for (const installment of additionalPaymentMethod.installments) {
					installment.cv8valor = additionalPaymentMethod.installmentValue
				}
				store.state.additionalPaymentMethods[store.state.additionalPaymentMethods.findIndex(item => item.id == cv8.additionalPaymentMethodId)] = additionalPaymentMethod
			}
			store.dispatch("calculateCv8", {})
		},
		removeAllAdditionalPaymentMethod(store, additionalPaymentMethodId) {
			store.state.additionalPaymentMethods = store.state.additionalPaymentMethods.filter(item => 
				item.id != additionalPaymentMethodId 
			)
			store.dispatch("calculateCv8", {})
		},
		async calculateCv8(store, {changedDueDate = false}){
			let lxd = store.rootState.lxd.lxd
			
			if(!store.getters.hasCompletedTransactionWhileTef){
				store.state.calculatingInstallments = true
				store.state.isFirstCalculation = false
				//armazenando números dos cheques
				let lstCheque = []
				for (const cv8 of store.state.lstCv8.filter(cv8 => cv8.cv8codnfce == Enums.CodNFCE.Cheque && !cv8.additionalPaymentMethodId)) {
					lstCheque.push({
						installment: "",
						cmc7: cv8.cv8cmc7,
						bank: cv8.cv8agente,
						dueDate: cv8.cv8vencim,
						interval: cv8.interval,
						term: cv8.term,
						agency: cv8.agency,
						cv8conta: cv8.cv8conta,
						ownerName: !!store.state.vd1.cf1 && store.state.vd1.vd1cliente != cv8.ownerDocument ? store.state.vd1.cf1.cf1nome ?? "" : cv8.ownerName,
						ownerDocument: store.state.vd1.vd1cliente != cv8.ownerDocument ? store.state.vd1.vd1cliente : cv8.ownerDocument
					})
				}

				//validar valores negativos
				if(store.state.lxdtitulo1 < 0)
					store.state.lxdtitulo1 = 0
				if(store.state.lxdtitulo2 < 0)
					store.state.lxdtitulo2 = 0
				if(store.state.lxdtitulo3 < 0)
					store.state.lxdtitulo3 = 0
				if(store.state.vd1.vd1vltroca < 0)
					store.state.vd1.vd1vltroca = 0
				
				
				let vlcash = store.state.vd1.vd1vlcash ? store.state.vd1.vd1vlcash : 0
				let amount = store.getters.itemsAmount + store.state.vd1.vd1vlfrete - store.state.vd1.vd1descon - vlcash
				if(!!store.state.vd1.otherExpenses && Object.keys(store.state.vd1.otherExpenses).length > 0 && store.state.vd1.otherExpenses.constructor === Object)
					amount += store.state.vd1.otherExpenses.cv5outras

				let sumcv8 = 0
				let lxdtitulo1 = store.state.lxdtitulo1
				let lxdtitulo2 = store.state.lxdtitulo2
				let lxdtitulo3 = store.state.lxdtitulo3
				store.state.vd1.vd1vltroca = parseFloat(store.state.vd1.vd1vltroca.toFixed(2))
				let vd1vltroca = store.state.vd1.vd1vltroca
				let installment = 1
				let lstCv8 = []

				let cv8vencim = moment().format("YYYY-MM-DD");
				if (lxdtitulo1) {
					let cv2titulo1 = await store.dispatch("cv2/get", lxd.lxdtitulo1, { root: true })
					if (!cv2titulo1) {
						store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: `Não foi possível calcular as parcelas: título ${lxd.lxdtitulo1} não cadastrado`
						}, { root: true })
						store.state.calculatingInstallments = false
						return false
					}
					lstCv8.push({
						cv8parcela: installment+"",
						cv8tipotit: lxd.lxdtitulo1,
						cv8cmc7: "",
						cv8valor: lxdtitulo1,
						cv8vencim: cv8vencim,
						cv8agente: "",
						cv8nsu: "",
						cv8band: "",
						cv8codnfce: cv2titulo1.nfceCode,
						cv8fixo: lxd.lxdtitulo1,
						interval: 0,
						term: 0,
						fixedValue: false,
						agency: "",
						cv8conta: "",
						ownerName: !!store.state.vd1.cf1 && cv2titulo1.nfceCode == Enums.CodNFCE.Cheque ? store.state.vd1.cf1.cf1nome : "",
						ownerDocument: cv2titulo1.nfceCode == Enums.CodNFCE.Cheque ? store.state.vd1.vd1cliente : "",
						additionalPaymentMethodId: null,
						cv8pdvgrup: ""
					})
					installment++
				}
				if (lxdtitulo2) {
					let cv2titulo2 = await store.dispatch("cv2/get", lxd.lxdtitulo2, { root: true })
					if (!cv2titulo2) {
						store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: `Não foi possível calcular as parcelas: título ${lxd.lxdtitulo2} não cadastrado`
						}, { root: true })
						store.state.calculatingInstallments = false
						return false
					}
					lstCv8.push({
						cv8parcela: installment+"",
						cv8tipotit: lxd.lxdtitulo2,
						cv8cmc7: "",
						cv8valor: lxdtitulo2,
						cv8vencim: cv8vencim,
						cv8agente: "",
						cv8nsu: "",
						cv8band: "",
						cv8codnfce: cv2titulo2.nfceCode,
						cv8fixo: lxd.lxdtitulo2,
						interval: 0,
						term: 0,
						fixedValue: false,
						agency: "",
						cv8conta: "",
						ownerName: !!store.state.vd1.cf1 && cv2titulo2.nfceCode == Enums.CodNFCE.Cheque ? store.state.vd1.cf1.cf1nome : "",
						ownerDocument: cv2titulo2.nfceCode == Enums.CodNFCE.Cheque ? store.state.vd1.vd1cliente : "",
						additionalPaymentMethodId: null,
						cv8pdvgrup: ""
					})
					installment++
				}
				if (lxdtitulo3) {
					let cv2titulo3 = await store.dispatch("cv2/get", lxd.lxdtitulo3, { root: true })
					if (!cv2titulo3) {
						store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: `Não foi possível calcular as parcelas: título ${lxd.lxdtitulo3} não cadastrado`
						}, { root: true })
						store.state.calculatingInstallments = false
						return false
					}
					lstCv8.push({
						cv8parcela: installment+"",
						cv8tipotit: lxd.lxdtitulo3,
						cv8cmc7: "",
						cv8valor: lxdtitulo3,
						cv8vencim: cv8vencim,
						cv8agente: "",
						cv8nsu: "",
						cv8band: "",
						cv8codnfce: cv2titulo3.nfceCode,
						cv8fixo: lxd.lxdtitulo3,
						interval: 0,
						term: 0,
						fixedValue: false,
						agency: "",
						cv8conta: "",
						ownerName: !!store.state.vd1.cf1 && cv2titulo3.nfceCode == Enums.CodNFCE.Cheque ? store.state.vd1.cf1.cf1nome : "",
						ownerDocument: cv2titulo3.nfceCode == Enums.CodNFCE.Cheque ? store.state.vd1.vd1cliente : "",
						additionalPaymentMethodId: null,
						cv8pdvgrup: ""
					})
					installment++
				}
				if (vd1vltroca) {
					let cv2vltroca = await store.dispatch("cv2/get", lxd.lxdtitulod, { root: true })
					if (!cv2vltroca) {
						store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: `Não foi possível calcular as parcelas: título ${lxd.lxdtitulod} não cadastrado`
						}, { root: true })
						store.state.calculatingInstallments = false
						return false
					}
					lstCv8.push({
						cv8parcela: installment+"",
						cv8tipotit: lxd.lxdtitulod,
						cv8cmc7: "",
						cv8valor: vd1vltroca,
						cv8vencim: cv8vencim,
						cv8agente: "",
						cv8nsu: "",
						cv8band: "",
						cv8codnfce: cv2vltroca.nfceCode,
						cv8fixo: lxd.lxdtitulod,
						interval: 0,
						term: 0,
						fixedValue: false,
						agency: "",
						cv8conta: "",
						ownerName: cv2vltroca.nfceCode == Enums.CodNFCE.Cheque ? store.state.vd1.cf1.cf1nome : "",
						ownerDocument: cv2vltroca.nfceCode == Enums.CodNFCE.Cheque ? store.state.vd1.vd1cliente : "",
						additionalPaymentMethodId: null,
						cv8pdvgrup: ""
					})
					installment++
				}

				store.state.additionalPaymentMethods.forEach(additionalPaymentMethod => {
					store.dispatch("checkRoundingDifference", { lstCv8: additionalPaymentMethod.installments, amount: additionalPaymentMethod.value })
					additionalPaymentMethod.installments.forEach(newInstallment => {
						newInstallment.cv8parcela = installment.toString()
						newInstallment.additionalPaymentMethodId = additionalPaymentMethod.id
						lstCv8.push(newInstallment)
						installment++
					}) 
				})

				if (store.getters.orderAmount < 0) {
					store.state.additionalPaymentMethods = []
					store.state.lstCv8 = lstCv8
					store.state.lstCv8 = store.state.lstCv8.filter(cv8 => {
						return !cv8.additionalPaymentMethodId || !!store.state.additionalPaymentMethods.find(ad => cv8.additionalPaymentMethodId == ad.id)
					})
					for (const cv8 of store.state.lstCv8.filter(cv8 => cv8.cv8codnfce == Enums.CodNFCE.Cheque && !cv8.additionalPaymentMethodId)) {
						let installmentCheque = lstCheque.find(i => !i.installment)
						if(!!installmentCheque){
							cv8.cv8cmc7 = installmentCheque.cmc7
							cv8.cv8agente = installmentCheque.bank
							installmentCheque.installment = cv8.cv8parcela
							if (!changedDueDate){
								cv8.cv8vencim = installmentCheque.dueDate
								cv8.interval = installmentCheque.interval
								cv8.term = installmentCheque.term
								cv8.agency = installmentCheque.agency
								cv8.cv8conta = installmentCheque.cv8conta
								cv8.ownerName = installmentCheque.ownerName
								cv8.ownerDocument = installmentCheque.ownerDocument
							}
						}
					}
					store.state.calculatingInstallments = false
					return true
				}

				sumcv8 = lstCv8.reduce(reduceSumCv8, 0)

				amount = parseFloat((amount).toFixed(2))
				sumcv8 = parseFloat((sumcv8).toFixed(2))

				if (sumcv8 > amount && store.getters.itemsOnCart > 0) {
					store.dispatch("parameters/openDialog", {
						titleText: "Aviso",
						titleColor: "#f8bb86",
						text: "Valor das parcelas excedeu total da nota. <br/>Os valores de condições a vista e múltiplos parcelamentos serão zerados."
					}, { root: true })
					store.state.lxdtitulo1 = 0
					store.state.lxdtitulo2 = 0
					store.state.lxdtitulo3 = 0
					store.state.calculatingInstallments = false
					store.state.additionalPaymentMethods = []
					store.state.lstCv8 = store.state.lstCv8.filter(cv8 => {
						return !cv8.additionalPaymentMethodId || !!store.state.additionalPaymentMethods.find(ad => cv8.additionalPaymentMethodId == ad.id)
					})
					store.dispatch("calculateCv8")
					return false
				}
				//parcelando conforme título/condição de pagamento selecionada
				if (store.getters.itemsOnCart > 0 && amount > sumcv8) {
					let amountAdditional = store.state.additionalPaymentMethods.reduce((accumulator, ap) => accumulator + ap.value, 0)
					amount -= amountAdditional
					sumcv8 -= amountAdditional

					if (store.state.lastFormCv8 == Enums.PaymFormCV8.CONPGTO) {
						if (!!store.state.vd1.vd1conpgto) {
							let vd4 = await store.dispatch("vd4/get", store.state.vd1.vd1conpgto, { root: true })
							if (vd4) {
								let installmentValue = await store.dispatch("getInstallmentValue", { amount, sumcv8, installments: vd4.lstVd9.length })
								let cv2cv8Form = await store.dispatch("cv2/get", vd4.vd4titulo, { root: true })
								store.state.cv8Form.installments = vd4.lstVd9.length > 0 ? vd4.lstVd9.length : 0
								store.state.cv8Form.days = vd4.lstVd9.length > 0 ? vd4.lstVd9[0].vd9caren : 0
								store.state.cv8Form.cv2titulo = vd4.vd4titulo
								for (let index = 0; index < vd4.lstVd9.length; index++) {
									const vd9 = vd4.lstVd9[index];
									let days = vd9.vd9caren
									let cv8ToAdd
									cv8ToAdd = await store.dispatch("generateInstallment", { cv8vencim, days, installment, cv2cv8Form, installmentValue })
									lstCv8.push(cv8ToAdd)
									cv8vencim = cv8ToAdd.cv8vencim
									installment++
								}
								//ajustando diferença no arredondamento das parcelas
								store.dispatch("checkRoundingDifference", { lstCv8 : lstCv8.filter(installment => installment.additionalPaymentMethodId == null), amount })
							}
						}
					} else if (store.state.lastFormCv8 == Enums.PaymFormCV8.MANUAL && store.state.cv8Form.cv2titulo) {
						let installmentValue = await store.dispatch("getInstallmentValue", { amount, sumcv8, installments: store.state.cv8Form.installments })
						let cv2cv8Form = await store.dispatch("cv2/get", store.state.cv8Form.cv2titulo, { root: true })
						for (let index = 0; index < store.state.cv8Form.installments; index++) {
							let days = store.state.cv8Form.days
							let cv8ToAdd = await store.dispatch("generateInstallment", { cv8vencim, days, installment, cv2cv8Form, installmentValue })
							lstCv8.push(cv8ToAdd)
							cv8vencim = cv8ToAdd.cv8vencim
							installment++
						}
						//ajustando diferença no arredondamento das parcelas
						store.dispatch("checkRoundingDifference", { lstCv8: lstCv8.filter(installment => installment.additionalPaymentMethodId == null), amount })
					}
				}

				if (lstCv8 != null && store.state.cv6 != null) {
					let sumInterval = lstCv8.reduce((accumulator, cv8) => accumulator + parseInt(cv8.interval),0)
					if (sumInterval > store.state.cv6.cv6prazmax) {
						store.dispatch("parameters/showSnackBar", {
							show: true,
							timeout: 3000,
							text: `Prazo máximo de dias das parcelas ultrapassa o prazo máximo da lista (${store.state.cv6.cv6prazmax} dias)`,
							color: "red"
						}, { root: true })
					}
				}

				store.state.lstCv8 = lstCv8
				for (const cv8 of store.state.lstCv8.filter(cv8 => cv8.cv8codnfce == Enums.CodNFCE.Cheque && !cv8.additionalPaymentMethodId)) {
					let installmentCheque = lstCheque.find(i => !i.installment)
					if(!!installmentCheque){
						cv8.cv8cmc7 = installmentCheque.cmc7
						cv8.cv8agente = installmentCheque.bank
						installmentCheque.installment = cv8.cv8parcela
						if (!changedDueDate){
							cv8.cv8vencim = installmentCheque.dueDate
							cv8.interval = installmentCheque.interval
							cv8.term = installmentCheque.term
							cv8.agency = installmentCheque.agency
							cv8.cv8conta = installmentCheque.cv8conta
							cv8.ownerName = installmentCheque.ownerName
							cv8.ownerDocument = installmentCheque.ownerDocument
						}
					}
				}
				store.dispatch("saveCartLocalStorage")
				store.state.calculatingInstallments = false
				return true
			}
		},
		generateInstallment(store, { cv8vencim, days, installment, cv2cv8Form, installmentValue}){
			let lxa = store.rootState.lxa.lxa
			let dueDate = moment(cv8vencim).add(days, 'days');

			if (lxa.lxadiautil){
				if (dueDate.isoWeekday() == 7) {
					dueDate.add(1, "days")
					days++
				}
				if (dueDate.isoWeekday() == 6) {
					dueDate.add(2, "days")
					days+=2
				}
			}

			if (store.state.vd1.cf1 && store.state.vd1.cf1.cf1melvcto > 0 && cv2cv8Form.cv2codnfce != Enums.CodNFCE.CartaoDeDebito && cv2cv8Form.cv2codnfce != Enums.CodNFCE.Dinheiro && cv2cv8Form.cv2codnfce != Enums.CodNFCE.PIX && cv2cv8Form.cv2codnfce != Enums.CodNFCE.ValePresente) {
				let year = dueDate.format('YYYY');
				let month = dueDate.format('MM');
				dueDate = moment(`${year}-${month}-${store.state.vd1.cf1.cf1melvcto}`, 'YYYY-MM-DD');		
			} 
			
			return {
				cv8parcela: installment+"",
				cv8tipotit: cv2cv8Form.cv2titulo,
				cv8cmc7: "",
				cv8valor: installmentValue,
				cv8vencim: dueDate.format("YYYY-MM-DD"),
				cv8agente: "",
				cv8nsu: "",
				cv8band: "",
				cv8codnfce: cv2cv8Form.nfceCode,
				cv8fixo: "",
				interval: Number(days),
				term: Math.ceil((dueDate - new Date()) / (1000 * 60 * 60 * 24)),
				fixedValue: false,
				agency: "",
				cv8conta: "",
				ownerName: cv2cv8Form.nfceCode == Enums.CodNFCE.Cheque && store.state.vd1.cf1 ? store.state.vd1.cf1.cf1nome : "",
				ownerDocument: cv2cv8Form.nfceCode == Enums.CodNFCE.Cheque && store.state.vd1.cf1 ? store.state.vd1.vd1cliente : "",
				additionalPaymentMethodId: null,
				cv8pdvgrup: ""
			}	
		},
		getInstallmentValue(store, { amount, sumcv8, installments }){
			return parseFloat(((amount - sumcv8) / installments).toFixed(2))
		},
		calculateAndAddDifference(store, { lstCv8, amount, first }) {
			const sumWithDecimals = lstCv8.reduce((total, cv8) => total + cv8.cv8valor, 0);
			const difference = (amount * 100 - sumWithDecimals * 100) / 100;
			let lstInstallments = lstCv8.filter(cv8 => !cv8.cv8fixo)
			var cv8valor = lstInstallments[first ? 0 : lstInstallments.length - 1].cv8valor += difference;
			if (cv8valor <= 0) 
				lstInstallments[first ? 0 : lstInstallments.length - 1].cv8valor = 0.01
		},
		checkRoundingDifference(store, { lstCv8, amount }) {
			if (!lstCv8 || lstCv8.length == 0)
				return

			var sumcv8 = lstCv8.reduce((accumulator, value) => accumulator + (parseFloat(value.cv8valor.toFixed(2))), 0.0)
			var difference = amount - sumcv8
			var lastCv8Value = lstCv8[lstCv8.length - 1].cv8valor
			amount = parseFloat(amount.toFixed(2))

			let lxa = store.rootState.lxa.lxa
			switch (lxa.lxaarredon) {
				case 2:
					// Arredondar segundos decimais e deixar resto pra ultima parcela. ex: 10.10, 10.10, 10.14
					for (const cv8 of lstCv8) {
						if (!!cv8.cv8fixo) {
							continue;
						}
						if (lstCv8.length > 1 && cv8.cv8parcela != lstCv8.length) {
							const roundedDecimal = Math.floor(cv8.cv8valor % 1 * 10) / 10
							const valueFloor = Math.floor(cv8.cv8valor)
							cv8.cv8valor = valueFloor + roundedDecimal
						}
					}
					// Adicionar a diferença ao último cv8valor para incluir decimais restantes
					store.dispatch("calculateAndAddDifference", { lstCv8, amount })
					break
				case 3:
					// Arredondar decimais e deixar resto pra ultima parcela. ex: 10, 10, 10.34
					for (const cv8 of lstCv8) {
						if (!!cv8.cv8fixo) {
							continue;
						}
						if (lstCv8.length > 1 && cv8.cv8parcela != lstCv8.length) {
							cv8.cv8valor = Math.floor(cv8.cv8valor)
						}
					}
					// Adicionar a diferença ao último cv8valor para incluir decimais restantes
					store.dispatch("calculateAndAddDifference", { lstCv8, amount })
					break
				case 4:
					// Arredondar decimais e deixar resto pra primeira parcela. ex: 10.34, 10, 10
					for (const cv8 of lstCv8) {
						if (!!cv8.cv8fixo) {
							continue;
						}
						if (lstCv8.length > 1) {
							cv8.cv8valor = Math.floor(cv8.cv8valor)
						}
					}
					store.dispatch("calculateAndAddDifference", { lstCv8, amount, first: true })
					break
				default:
					var cv8valor = parseFloat((lastCv8Value + difference).toFixed(2))
					lstCv8[lstCv8.length - 1].cv8valor = cv8valor > 0 ? cv8valor : 0.01
					break
			}
		},
		async calculateCv8ByVd4(store){
			store.state.calculatingInstallments = true
			store.state.lastFormCv8 = Enums.PaymFormCV8.CONPGTO
			store.dispatch("calculateCv8", {changedDueDate: true})
			store.state.calculatingInstallments = false
		},
		async calculatePriceItems(store){
			return await this._vm.$axios.post("/Order/Cart/RecalculatePrices",
			{
				lstVd7: store.state.lstVd7,
				cpfCnpj: store.state.vd1.vd1cliente,
				list: store.state.vd1.vd1lista
			})
			.then(response => {
				let lstVd7 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstVd7 = lstVd7
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
		},
		async validateTransmit(store, isTefTransaction){
			let lxd = store.rootState.lxd.lxd
			if (lxd.lxdintesho && !store.state.transmit) {
				store.dispatch("parameters/openDialog", {
					titleText: "Aviso",
					titleColor: "#f8bb86",
					text: "Deseja mesmo não transmitir a venda para o shopping?",
					confirmBtn: true,
					confirmText: "Sim",
					confirmAction: async () => await store.dispatch("checkPrintVolumeLabel", isTefTransaction),
					cancelText: "Não",
					cancelAction: async () => {
						store.state.transmit = true
						await store.dispatch("checkPrintVolumeLabel", isTefTransaction)
					}
				}, { root: true })
				return false
			}
			return true
		},
		async checkPrintVolumeLabel(store, isTefTransaction){
			let lxd = store.rootState.lxd.lxd
			if (lxd.lxdetiqvol) {
				setTimeout(() => {
					store.dispatch("parameters/openDialog", {
						titleText: "Impressão etiqueta de volume",
						titleColor: "#f8bb86",
						showTextBox: true,
						focusOnField: true,
						typeTextBox: "number",
						defaultTextBoxValue: 0,
						placeholderTextBox: "Digite o número de volumes...",
						confirmBtn: true,
						confirmText: "Imprimir",
						confirmAction: async () => {
							try {
								if(store.rootState.parameters.dialog.responseText)
									store.state.qtyVolumeLabel = parseInt(store.rootState.parameters.dialog.responseText)
								else
									store.state.qtyVolumeLabel = 0
							} catch (error) {
								store.state.qtyVolumeLabel = 0
							}
							if(store.state.qtyVolumeLabel < 0)
								store.state.qtyVolumeLabel = 0
							await store.dispatch("save", isTefTransaction)
						},
						cancelText: "Não imprimir",
						cancelAction: async () => {
							store.state.qtyVolumeLabel = 0
							await store.dispatch("save", isTefTransaction)
						}
					}, { root: true })
				}, 500)
				return false
			}
			await store.dispatch("save", isTefTransaction)
			return true
		},
		async print(store, { cv5pedido, cv5embarq, download = false}){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: `${download ? "Baixando documentos do" : "Imprimindo"} pedido ${cv5pedido} embarque ${cv5embarq}` , indeterminate: true }, {root: true})
			await this._vm.$axios.post(`/Order/Order/Print/${cv5pedido}/${cv5embarq}`)
			.then(response => {
				let relatsPath = Utils.ValidateAxiosResponse(response.data);

				if(relatsPath && relatsPath.length > 0){
					if(download)
						store.dispatch("print/downloadFile", relatsPath, { root: true })
					else
						store.dispatch("print/openRelatsPath", relatsPath, { root: true })
				}

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return true
		},
		nextTabBody(store){
			let lxd = store.rootState.lxd.lxd
			let tabs = lxd.lxdabaoutr ? 3 : 2
			store.state.tabBody++
			if(store.state.tabBody > tabs)
				store.state.tabBody = 0
		},
		async findShipForSaleConfirmation(store, vd1pedido){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Localizando embarques abertos para o pedido " + vd1pedido , indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get(`/Order/Shipment/FindForSaleConfirmation/${vd1pedido}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		showShoppingMessages(store, messages){
			store.state.shoppingMessages = messages
		},
		setLimitShoppingIntegration(store, limit){
			store.state.limitShoppingIntegration = limit
		},
		requestEmitNF(store, payload){
			let lxd = store.rootState.lxd.lxd

			let cancelText = ""
			let cancelAction = null
			let confirmBtn = false
			let confirmText = ""
			let confirmAction = null
			let showOption2 = false
			let option2Text = ""
			let option2Action = null
			let dialogOptionsForEditNF = {
				titleText: "Emissão de documento fiscal",
				titleColor: "#f8bb86",
				text: "Como deseja emitir o documento fiscal?",
				cancelText: "Editar",
				cancelAction: () => {
					let vd1pedido = store.state.vd1.vd1pedido
					store.dispatch("removeCartLocalStorage", store.state.vd1.id )
					store.dispatch("clearCart")
					setTimeout(() => {
						window.open(`/oryxpdv/venda/${vd1pedido}?toIssueFiscalDocument=true`, "_self")
					}, 1250);
				},
				confirmBtn: true,
				confirmText: "Automático",
				confirmAction: null
			}

			if(!lxd.lxdnf && !lxd.lxdnfce){
				cancelText = "Ok"
				cancelAction = () => {
					if (!payload.isError) {
						store.dispatch("clearCart")
						router.push("/oryxpdv/venda-concluida")
					}
				}
			}else{
				confirmBtn = true
				confirmText = "Ok"
				confirmAction = () => {
					if (!payload.isError) {
						store.dispatch("clearCart")
						router.push("/oryxpdv/venda-concluida")
					}
				}
				if (lxd.lxdnfce && !lxd.lxdnf) {
					cancelText = "Emitir CF"
					dialogOptionsForEditNF.confirmAction = () => {
						store.dispatch("emitFiscalDocument", { docfis: lxd.lxddocven3, isSales: true, isAutomatic: true })
					}
					cancelAction = () => {
						setTimeout(() => {
							store.dispatch("parameters/openDialog", dialogOptionsForEditNF, { root: true })
						}, 200);
					}
				}else{
					cancelText = "Emitir NF",
					dialogOptionsForEditNF.confirmAction = () => {
						store.dispatch("emitFiscalDocument", { docfis: lxd.lxddocven4, isSales: true, isAutomatic: true })
					}
					cancelAction = () => {
						setTimeout(() => {
							store.dispatch("parameters/openDialog", dialogOptionsForEditNF, { root: true })
						}, 200);
					}
					showOption2 = lxd.lxdnfce
					option2Text = "Emitir CF"
					let dialogOptionsForEditNF2 = {...dialogOptionsForEditNF}
					dialogOptionsForEditNF2.confirmAction = () => {
						store.dispatch("emitFiscalDocument", { docfis: lxd.lxddocven3, isSales: true, isAutomatic: true })
					}
					option2Action = () => {
						setTimeout(() => {
							store.dispatch("parameters/openDialog", dialogOptionsForEditNF2, { root: true })
						}, 200);
					}
				}
			}

			store.dispatch("parameters/openDialog", {
				titleText: payload.message,
				titleColor: "green",
				cancelText,
				cancelAction,
				confirmBtn,
				confirmText,
				confirmAction,
				showOption2,
				option2Text,
				option2Action,
			}, { root: true })
		},
		async emitFiscalDocument(store, { docfis = "", isSales = false, isAutomatic = false }){
			let lxd = store.rootState.lxd.lxd
			let lx0 = store.rootState.lx0.lx0
			let emitNFVd1Model
			let route = "/Order/Order/"
			const toIssueFiscalDocument = store.state.vd1.toIssueFiscalDocument

			if(!isSales && store.state.lstCv5.length == 0){
				setTimeout(() => {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: `Não é possível ${isAutomatic ? "gerar" : "editar"} documentos fiscais em pedidos que não foram faturados.`
					}, { root: true })
				})
				return false
			}

			if (toIssueFiscalDocument){
				route+="EmitEditedFiscalDocument"
				emitNFVd1Model = store.getters.vd1model
			}
			else{
				route+="EmitFiscalDocument"
				emitNFVd1Model = store.getters.emitNFVd1Model
			}

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Emitindo documento fiscal" , indeterminate: true }, {root: true})

			emitNFVd1Model.docfis = !!docfis ? docfis : lxd.lxddocven4

			let payload = await this._vm.$axios.post(route, emitNFVd1Model)
			.then(async response => {
				let payloadEmitNFModel = Utils.ValidateAxiosResponse(response.data);

				if (!payloadEmitNFModel.isError && (!isSales || toIssueFiscalDocument) && store.rootState.lxd && store.rootState.lxd.lxd.lxdtef) 
					await this._vm.$tefAxios.put("/TEF/ExecuteAllTransactions/" + store.state.vd1.vd1pedido )
				
				store.dispatch("parameters/openDialog", {
					titleText: payloadEmitNFModel.isError ? "Erro" : payloadEmitNFModel.message,
					titleColor: payloadEmitNFModel.isError ? "red" : "green",
					text: payloadEmitNFModel.isError ? payloadEmitNFModel.message : "",
					cancelText: payloadEmitNFModel.isError && !toIssueFiscalDocument ? "Abandonar" : "Ok",
					cancelAction: async () => {
						if (!payloadEmitNFModel.isError) {
							let success = true

							if(!(lxd.lxdromabol && store.getters.vd1model.docfis == lxd.lxddocven1))
								success = await store.dispatch("emitBankSlipByPaymentCondition");
							if (lx0.lx0email && success && docfis && docfis != lxd.lxddocven1 && docfis != lxd.lxddocven2) {
								await store.dispatch("sendNfeEmailByOrder", { vd1pedido: store.state.vd1.vd1pedido, vd1cliente: store.state.vd1.vd1cliente })
							}

							store.dispatch("clearCart")
							if (isSales)
								router.push("/oryxpdv/venda-concluida")
							else
								router.push("/oryxpdv/pedidos")
						}else {
							if (!isSales && !toIssueFiscalDocument)
								router.push("/oryxpdv/pedidos")
						}
					},
					confirmBtn: payloadEmitNFModel.isError && !toIssueFiscalDocument ? true : false,
					confirmText: payloadEmitNFModel.isError ? "Tentar novamente" : "",
					confirmAction: () => {
						store.dispatch("emitFiscalDocument", { docfis, isSales, isAutomatic })
					}
				}, { root: true })

				if(payloadEmitNFModel.relatPath){
					store.dispatch("print/openRelatsPath", [payloadEmitNFModel.relatPath], { root: true })
				}
				if(!!payloadEmitNFModel.extraRelatPath && payloadEmitNFModel.extraRelatPath.length > 0){
					store.dispatch("print/openRelatsPath", payloadEmitNFModel.extraRelatPath, { root: true })
				}
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async hasFiscalDocument(store, vd1pedido){
			return await this._vm.$axios.get("/Order/Order/HasFiscalDocument/" + vd1pedido)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return true
			});
		},
		async calculatevd1vltroca(store){
			let lxd = store.rootState.lxd.lxd

			if (lxd.lxdmultrom && store.state.lstVd7.length > 1){
				//percorrer cada volume e zerar os descontos, e calcular o total de crédito daquele cliente
				for (const vd7 of store.state.lstVd7) {
					const itemsAmount = (accumulator, item) => accumulator + item.total

					//apurar o crédito daquele cliente (troca + crédito)
					const customerOldCreditAmount = (accumulator, item) => accumulator + item.customerOldCredit
					let vd1vltroca = store.state.lstVd7.filter(v => v.vd1cliente == vd7.vd1cliente).reduce(customerOldCreditAmount, 0)

					let amountReturn = 0
					const filterOnlySales = (item) => !item.consigned
					const filterCustomer = (cart) => cart.vdkcliente == vd7.vd1cliente
					for (const cart of store.rootState.vdk.carts.filter(filterCustomer)) {
						amountReturn += cart.lstItems.filter(filterOnlySales).reduce(itemsAmount, 0)
					}

					vd1vltroca += amountReturn

					//descontar os valores de carrinhos anteriores desse mesmo cliente
					const filterAfterVolumes = v => v.vd1cliente == vd7.vd1cliente && parseInt(v.vd7volume) < parseInt(vd7.vd7volume)
					for (const volume of store.state.lstVd7.filter(filterAfterVolumes)) {
						vd1vltroca -= volume.items.reduce(itemsAmount,0)
					}

					let currentAmount = vd7.items.reduce(itemsAmount,0)
					//caso não sobre saldo, então informar esse crédito no campo vd7.vd1vltroca
					if (currentAmount > vd1vltroca) {
						if(vd1vltroca <= 0){
							vd7.vd1vltroca = 0
						}else{
							vd7.vd1vltroca = vd1vltroca
						}
					}else{
						//caso sobre saldo, colocar tudo no último romaneio (caso seja o último romaneio daquele cliente)
						//ou o total do carrinho atual em vd7.vd1vltroca
						//let lstVolumeCustomer = store.state.lstVd7.filter(v => v.vd1cliente == vd7.vd1cliente)
						//let lastVolumeCustomer = lstVolumeCustomer[lstVolumeCustomer.length -1]
						// if (!!lastVolumeCustomer && lastVolumeCustomer.vd7volume == vd7.vd7volume) {
						// 	vd7.vd1vltroca = vd1vltroca
						// }else{
							vd7.vd1vltroca = currentAmount
						// }
					}
				}

				let vd1vltroca = 0
				for (const vd7 of store.state.lstVd7) {
					vd1vltroca += vd7.vd1vltroca
				}
				store.state.vd1.vd1vltroca = vd1vltroca

				return true
			}

			store.state.vd1.vd1vltroca = store.state.customerOldCredit

			if(lxd.lxddevven){
				let amountReturnSales = store.rootGetters["vdk/amountReturnSales"]
				store.state.vd1.vd1vltroca += amountReturnSales
			}

			store.state.vd1.vd1vltroca = parseFloat(store.state.vd1.vd1vltroca.toFixed(2))

			return true
		},
		async findAllCv5(store, vd1pedido){
			return await this._vm.$axios.get("/Order/Order/FindAllCv5/" + vd1pedido)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async cancel(store, params){
			params.vd1pedido = store.state.vd1.vd1pedido
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Cancelando pedido", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Order/Order/Cancel", params)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);

				store.dispatch("parameters/openDialog", {
					titleText: "Cancelamento realizado com sucesso",
					titleColor: "green",
					text: payload.resale ? "Você será redirecionado para refazer a venda." : "",
					cancelAction: () => {
						if(payload.resale)
							router.push({ path: "/oryxpdv/venda", query: { resales: true, lstVd7: payload.lstVd7, cf1cliente: payload.cf1cliente }})
						else
							router.push("/oryxpdv/pedidos")
					}
				}, { root: true })

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message,
					cancelText: "Cancelar",
					confirmBtn: true,
					confirmText: "Tentar novamente",
					confirmAction: () => {
						store.dispatch("cancel", params)
					}
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async printReportItensByOrder(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Order/Order/PrintReportItensByOrder", params)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async getNextNumber(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando próximo número de pedido", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.get("/Order/Order/GetNextNumber/")
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return ""
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async sendNfeEmailByOrder(store, { vd1pedido, vd1cliente }){
			let customReceiver = await store.dispatch("cfe/findEmailDocFis", vd1cliente , { root : true})

			return await store.dispatch("cv5/sendNfeEmailByOrder",
			{
				order: vd1pedido,
				ship: store.state.shipSequence,
				customReceiver,
				transporter: !!store.state.vd1.vd1transp
			}, { root: true })
		},
		async hydrateWhatsappSendCapability({ dispatch, commit }, { vd1pedido } = {}) {
			commit("setWhatsappCapabilityLoading", true)
			try {
				const response = await this._vm.$axios.get("/Order/Order/ValidateWhatsappSendCapability", {
					headers: { "Content-Type": "application/json", company: localStorage.getItem("companyCode") },
					params: { vd1pedido },
				})
				commit("hydrateWhatsappSendCapability", Utils.ValidateAxiosResponse(response.data))
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return { success: false, reason: error.message }
			} finally {
				commit("setWhatsappCapabilityLoading", false)
			}
		},
		async sendOrderWhatsApp({ dispatch }, { vd1pedido } = {}) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Agendando envio de mensagem", indeterminate: true },
				{ root: true },
			)

			try {
				const response = await this._vm.$axios.post(
					"/Order/Order/SendWhatsAppMessage",
					{},
					{ params: { vd1pedido } },
				)

				const data = Utils.ValidateAxiosResponse(response.data)

				if (data === true) {
					dispatch(
						"parameters/showSnackBar",
						{
							show: true,
							timeout: 3000,
							text: "Mensagem do pedido agendada! O cliente a vai receber em breve.",
							color: "green",
						},
						{ root: true },
					)
					return true
				}

				dispatch(
					"parameters/openDialog",
					{ titleText: "Erro", titleColor: "red", text: "Não foi possível agendar/enviar a mensagem." },
					{ root: true },
				)
				return false
			} catch (error) {
				dispatch("parameters/openDialog", { titleText: "Erro", titleColor: "red", text: error.message }, { root: true })
				return false
			} finally {
				dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			}
		},
		selectvd1transp(store, vd1transp){
			if(vd1transp){
				store.dispatch("cf7/get", vd1transp, { root: true })
				.then(cf7 => {
					if(cf7 && cf7.cf7cliente){
						store.dispatch("cf1/get", {cf1cliente: cf7.cf7cliente}, { root: true })
						.then(cf1 =>{
							store.state.transporterInfos = {
								cv5trcnpj: cf1.cf1cliente,
								cv5trinscr: cf1.cf1insest,
								cv5trender: cf1.cf1ender1 + ", " + cf1.cf1numero,
								cv5trlocal: cf1.cf3nome,
								cv5trestad: cf1.cf3estado
							}
							store.dispatch("saveCartLocalStorage")
						})
						return true
					}else{
						store.state.transporterInfos = {}
					}
				})
			}else{
				store.state.transporterInfos = {}
			}
			store.dispatch("saveCartLocalStorage")
		},
		calculateWeight(store){
			store.state.vd1.shippingInfoOfOrderModel.cv5pesobru = store.getters.grossWeightAmount
			store.state.vd1.shippingInfoOfOrderModel.cv5pesoliq = store.getters.netWeightAmount
		},
		checkStockForVdItem(store, { vd2produto, vd3opcao, vd3tamanho, stock }){
			//pegando o volume
			let vd7 = store.state.lstVd7[store.state.tabVdItem]
			if (vd7) {
				let qtdeSales = 0

				if (!vd3opcao && !vd3tamanho) {
					qtdeSales = vd7.items.filter(vditem =>
						vditem.vd2produto == vd2produto &&
						!vditem.onlyNF)
						.reduce((accumulator, vditem) => accumulator + vditem.vd3qtde, 0)
				}else{
					qtdeSales = vd7.items.filter(vditem =>
						vditem.vd2produto == vd2produto &&
						vditem.vd3opcao == vd3opcao &&
						vditem.vd3tamanho == vd3tamanho &&
						!vditem.onlyNF)
						.reduce((accumulator, vditem) => accumulator + vditem.vd3qtde, 0)
				}

				if ((stock - qtdeSales) < 0 ) {
					var audioErro = new Audio(scanErro);
					audioErro.play();
					store.dispatch("parameters/openDialog", {
						titleText: "Aviso",
						titleColor: "#f8bb86",
						text: "Produto sem estoque disponível"
					}, { root: true })
				}
			}
		},
		async insertNextVd7(store){
			let vd7 = store.state.lstVd7.filter(vd7 => !vd7.issued)[0]

			if (!vd7.vd1pedido)
				vd7.vd1pedido = await store.dispatch("getNextNumber")

			if (!!vd7.vd1pedido && !vd7.issued)
				store.dispatch("insertByVd7", { vd7 })
		},
		async insertByVd7(store, { vd7 }){
			let vd1model = JSON.parse(JSON.stringify(store.getters.vd1model))
			let lxd = store.rootState.lxd.lxd

			let amount = await store.dispatch("calculateCartSubtotal", vd7)

			// ajustando valor de troca para consumo do crédito
			if (amount < 0) {
				vd7.vd1vltroca = amount + vd7.vd1vltroca
				vd7.vd1vltroca = parseFloat(vd7.vd1vltroca.toFixed(2))
			}

			vd1model.lstVd7 = [ vd7 ]
			vd1model.vd1.vd1pedido = vd7.vd1pedido
			vd1model.vd1.vd1vend = vd7.vd1vend
			vd1model.vd1.vd1descon = vd7.vd1descon
			vd1model.vd1.vd1despon = vd7.vd1despon
			vd1model.vd1.vd1cliente = vd7.vd1cliente
			vd1model.vd1.vd1vltroca = vd7.vd1vltroca

			const grossWeightAmount = (accumulator, item) => {
				return accumulator + (!item.pr0pesobru ? 0 : item.pr0pesobru) * item.vd3qtde
			}
			vd1model.vd1.shippingInfoOfOrderModel.cv5pesobru = vd7.items.reduce(grossWeightAmount, 0)

			const netWeightAmount = (accumulator, item) => accumulator + (!item.pr0pesoliq ? 0 : item.pr0pesoliq) * item.vd3qtde
			vd1model.vd1.shippingInfoOfOrderModel.cv5pesoliq = vd7.items.reduce(netWeightAmount, 0)

			let vdk = store.rootState.vdk.vdk

			if (lxd.lxddevven && vdk) {
				let vdkmodel = store.rootGetters["vdk/vdkmodel"]

				vd1model.vdkmodel = vdkmodel
				vd1model.vdkmodel.carts = store.rootGetters["vdk/carts"]
				vd1model.vdkmodel.vdk.vdkcliente = vd1model.vd1.vd1cliente

				let tabVdItem = store.state.lstVd7.map(v => v.vd7volume).indexOf(vd7.vd7volume);
				let lstItems = vd1model.vdkmodel.carts[tabVdItem].lstItems

				if (!!lstItems && lstItems.length > 0) {
					vd1model.vdkmodel.lstItems = lstItems

					vd1model.vdkmodel.docReturn = store.rootGetters["vdk/docReturn"]

				}else{
					vd1model.vdkmodel = null
				}

				vd1model.othersAmountReturn = store.state.lstVd7.filter(v => v.vd7volume != vd7.vd7volume).reduce((accumulator, item) => accumulator + item.vd1vltroca,0)
			}

			if (vd7.vd7volume != "1") {
				vd1model.transmit = false
				vd1model.lstCv8 = []
				vd1model.vd1.vd1conpgto = lxd.lxdcondsvf
				vd1model.vd1.vd1pedpai = store.state.lstVd7[0].vd1pedido
				vd1model.vd1.vd1vltroca = 0
				vd1model.vd1.vd1vlfrete = 0
				if(!!vd1model.vd1.otherExpenses)
					vd1model.vd1.otherExpenses.cv5outras = 0
			}

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Gravando pedido", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Order/Order/Insert?multiple_receipt=true", vd1model )
			.then(async response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.state.vd1.codAuthSalesMall = payload.codAuthSalesMall
				store.state.billed = payload.billed
				store.state.isSavedVD1 = payload.isSavedVD1
				vd7.billed = payload.billed

				store.state.shipSequence = payload.shipSequence
				if (store.rootState.vdk.vdk && vd7.vd7volume == "1"){
					store.rootState.vdk.vdk.vdkdoc = payload.vdkdoc
				}

				if (!payload.isError) {
					vd7.issued = true

					if (
						store.rootState.vdk &&
						store.rootState.vdk.vdk
					) {
						store.rootState.vdk.vdk.vdkdoc = ""
					}

					if(payload.relatsPath && payload.relatsPath.length > 0){
						store.dispatch("print/openRelatsPath", payload.relatsPath, { root: true })
					}

					let success = await store.dispatch("emitBankSlipByPaymentCondition");

					if(!success)
						return false

					//seguir para o próximo romaneio
					let lastVd7 = store.state.lstVd7[store.state.lstVd7.length-1]
					if (lastVd7.vd7volume != vd7.vd7volume) {
						setTimeout(() => {
							store.dispatch("insertNextVd7")
						}, 1000);
					}else{
						store.dispatch("removeCartLocalStorage", vd1model.vd1.id )

						store.dispatch("parameters/openDialog", {
							titleText: payload.message,
							titleColor: "green",
							text: "",
							confirmBtn: true,
							confirmText: "Ok",
							confirmAction: () =>{
								store.dispatch("clearCart")
								router.push("/oryxpdv/venda-concluida")
							},
							cancelText: "Emitir Documento fiscal",
							cancelAction: () => {
								for (const vd7 of store.state.lstVd7) {
									window.open(`/oryxpdv/venda/${vd7.vd1pedido}?toIssueFiscalDocument=true`)
								}
								store.dispatch("clearCart")
								router.push("/oryxpdv/venda-concluida")
							}
						}, { root: true })
					}
				}else{
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: payload.message + (payload.enableNewOrderButton ? "<br/>Você pode <b>emitir uma nova venda</b> e gerar outro número de pedido, ou <b>abandonar a tela</b>.": ""),
						cancelText: payload.enableNewOrderButton ? "Emitir novo pedido" : "Ok",
						cancelAction: async () => {
							if(payload.enableNewOrderButton){
								vd7.vd1pedido = ""
								store.state.vd1.codAuthSalesMall = ""
								store.state.billed = false
								vd7.billed = false
								store.state.shipSequence = ""

								store.dispatch("insertNextVd7")
								return
							}
						},
						confirmText: "Ok",
						confirmBtn: payload.enableNewOrderButton
					}, { root: true })
				}

				store.dispatch("saveCartLocalStorage")

				return !payload.isError
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		calculateCartSubtotal(store, vd7){
			//apurando o total do carrinho
			const cartSubtotal = (accumulator, item) => accumulator + item.total
			let amount = vd7.items.reduce(cartSubtotal, 0)
			amount -= vd7.vd1descon
			amount -= vd7.vd1vltroca

			if (vd7.vd7volume == "1") {
				amount += store.state.vd1.vd1vlfrete
				if(!!store.state.vd1.otherExpenses && Object.keys(store.state.vd1.otherExpenses).length > 0 && store.state.vd1.otherExpenses.constructor === Object)
					amount += store.state.vd1.otherExpenses.cv5outras
			}
			return parseFloat(amount.toFixed(2))
		},
		async saveShipment(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Aplicando frete", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Order/Order/SaveShipment/"+store.state.vd1.vd1pedido, params )
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async resalesByUsedOrderNumber(store){
			//zerar informações do shopping e setar número do pedido nos demais objetos
			store.state.vd1.codAuthSalesMall = ""
			store.state.billed = false
			store.state.shipSequence = ""

			//se tiver fazendo update, precisa mudar para insert
			store.state.update = false
			store.state.insert = true

			store.dispatch("saveCartLocalStorage")

			//pegar novo número de pedido
			store.state.vd1.vd1pedido = await store.dispatch("getNextNumber")

			if (store.state.vd1.vd1pedido) {
				store.dispatch("insert")
			}
		},
		async enableBankSlipButton(store, vd1pedido){
			return await this._vm.$axios.get("/Order/Order/EnableBankSlipButton/" + vd1pedido)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return true
			});
		},
		async findForOrderSelect(store, text){
			return await this._vm.$axios.get("/Order/Order/FindForOrderSelect?search=" + text)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			});
		},
		async prepareInstallmentToTef(store, cv8){
			store.state.currentCv8Transaction = cv8
			
			const insert = store.state.insert

			const params = {
				lxd: store.rootState.lxd.lxd,
				vd1: store.state,
				vdk: store.rootState.vdk,
				isEANHasConsignment: false,
				vd1model: store.getters.vd1model.vd1,
				lstDc1: store.rootState.form.lstDc1,
				store: store,
				insert
			}

			const saveSuccess = await mixin.methods.saveVd1(true, "", params)
			if(insert || !saveSuccess) return;

			await store.dispatch("lxi/initCancelTokenSource", null, { root: true })
			.then(store.dispatch("lxi/sendInstallmentsToTef", { cancelToken: store.rootState.lxi.cancelTokenSource.token}, {root: true}))
		},
		async openInstallmentsByRoute(store){
			store.state.tabBody = 1
			setTimeout(() => {
				store.state.tabBody = 2
			})
			store.dispatch("saveCartLocalStorage");
			const cv8ToOpen = router.currentRoute.query.parcela
			const portion = store.state.lstCv8.find(el => el.cv8parcela == cv8ToOpen)
			if(cv8ToOpen && portion && !portion.cv8nsu){
				store.dispatch("prepareInstallmentToTef", store.state.lstCv8.find(el => el.cv8parcela == cv8ToOpen));
				const query = Object.assign({}, router.currentRoute.query);
				delete query.parcela;
				router.replace({ query });
			}
		},
		async printOnReturn(store, vd1model){
			let lxd = store.rootState.lxd.lxd
			let docfis = vd1model.docfis

			if(!(lxd.lxdtef && vd1model.print && docfis)) 
				return false

			if(store.rootState.pd1.lstPd1.length == 0)
				await store.dispatch("pd1/findList", store.rootState.pd0.pd0.pd0codigo, {root: true})

			const hasPrintPreference = (relat) => store.rootState.pd1.lstPd1.some(pd1 => pd1.pd1relat == relat && pd1.pd1impres)

			const cv1 = await store.dispatch("cv1/get", docfis, {root: true})
			const cv1relat = cv1.cv1relat

			if(hasPrintPreference(cv1relat))
				return true
			
			if((docfis == lxd.lxddocven3 || docfis == lxd.lxddocven4) && lxd.lxdromanf){
				let cv1Romaneio = await store.dispatch("cv1/get", lxd.lxddocven1, {root: true})
				if(hasPrintPreference(cv1Romaneio.cv1relat)){
					return true
				}
			}
			
			if(store.getters.hasCompletedTransactionWhileTef && hasPrintPreference("336"))
					return true

			return false
		},
		async emitBankSlipByPaymentCondition(store){
			let vd1model = store.getters.vd1model
			let lxd = store.rootState.lxd.lxd
			
			const filterBankSlip = cv8 => cv8.cv8codnfce == Enums.CodNFCE.Crediario || cv8.cv8codnfce == Enums.CodNFCE.BlqBancario
			let lstBankSlip = vd1model.lstCv8.filter(filterBankSlip)
			
			let success = true
			const isRomaneio = vd1model.docfis == lxd.lxddocven1
			const isInvoice = vd1model.docfis == lxd.lxddocven4 || vd1model.docfis == lxd.lxddocven3

			let hasBankSlipInOrder = false
			if(router.currentRoute.name != "sale")
				hasBankSlipInOrder = await store.dispatch("enableBankSlipButton", store.state.vd1.vd1pedido)

			//Valida se venda é romaneio e tem boleto pra venda romaneio
			const hasRomaneioAndParameter = lxd.lxdromabol && isRomaneio

			//Valida se venda é nota e tem boleto pra venda nota
			const hasInvoiceAndParameter = lxd.lxdnfbol && isInvoice

			//Valida se tem venda romaneio + nota, se for venda romaneio, o parametro hasRomaneioAndParameter é responsável pela
			//validação, já que venda romaneio só vai gerar documento de romaneio.Já se for venda nota, vai gerar nota e romaneio,
			//e fará a validação se existe parametro de boleto para algum dos dois documentos
			const hasBothAndParameter = lxd.lxdromanf && (isInvoice && (lxd.lxdromabol || lxd.lxdnfbol))

			if ((lstBankSlip != null && lstBankSlip.length > 0 || hasBankSlipInOrder) && (hasRomaneioAndParameter || hasInvoiceAndParameter || hasBothAndParameter)) {
				success = await store.dispatch("cv5/emitBankSlipByOrder", { vd1pedido: store.state.vd1.vd1pedido, print: vd1model.print }, { root: true })
			}
			
			return success
		},
		async recoverCashback({ dispatch, state }, vd1cash) {
			if(vd1cash != null && vd1cash != "") {
				const cb1 = await dispatch("cb1/get", vd1cash, { root: true })
				Vue.set(state.lstSelectedCashback, 0, cb1)
				if(state.lstSelectedCashback[0] == null || state.lstSelectedCashback[0].cb1fim < new Date() || state.lstSelectedCashback[0].cb1util) {
					state.lstSelectedCashback = []
					state.vd1.vd1vlcash = 0,
					state.vd1.vd1cash = ""
					await dispatch("vd1/calculateCv8", {})
				}
			}
		}
	}
}
